export default {
  data () {
    return {
      fields: {
        Diploma: ['Architecture',
          'Interior Design', 'Civil Engineering', 'Planning', 'Design', 'Other'],
        Undergraduate: ['Architecture',
          'Interior Design', 'Civil Engineering', 'Planning', 'Design', 'Other'],
        Postgraduate: ['Architecture', 'Urban Design', 'Urban Planning', 'Landscape', 'Building Engineering Management', 'Construction Management', 'Interior Design', 'Conservation', 'Product Design', 'Housing', 'Transportation Design', 'Other']
      },
      countries: [],
      chapters: [
        'Amravathi',
        'Ahmedabad',
        'Ahmednagar',
        'Bangalore',
        'Bharuch',
        'Bhopal',
        'Chandigarh',
        'Charotar',
        'Chennai',
        'Coimbatore',
        'New Delhi',
        'Goa',
        'HQ',
        'Hyderabad',
        'Indore',
        'Jaipur',
        'Kerala',
        'Kolhapur',
        'Kolkata',
        'Lucknow',
        'Mumbai',
        'Nagpur',
        'Nashik',
        'Pune',
        'Raipur',
        'Satara',
        'Saurashtra',
        'Surat',
        'Thane',
        'Vadodara',
        'Visakhapatnam',
        'Marathwada',
        'Dubai',
      ],
      archUniversities: [
        {
          "Region": "South",
          "College": "A. P. J. Abdul Kalam School Of Architecture, Mekkadambu"
        },
        {
          "Region": "South",
          "College": "Aalim Muhammed Salegh Academy of Architecture Nizara Educational Campus \n"
        },
        {
          "Region": "North",
          "College": "Aayojan School of Architecture"
        },
        {
          "Region": "West",
          "College": "Aayojan School Of Architecture and Design"
        },
        {
          "Region": "North",
          "College": "Abdul Ahad Azad Memorial Degree College, Bemina"
        },
        {
          "Region": "West",
          "College": "Academy Of Architecture"
        },
        {
          "Region": "North ",
          "College": "Accurate Institute of Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "Acharya’s NRV School Of Architecture"
        },
        {
          "Region": "West",
          "College": "ADA’s Minerva College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Aditya Academy Of Architecture & Design"
        },
        {
          "Region": "West",
          "College": "Aditya College Of Architecture, C/o Aditya Educational Campus \n"
        },
        {
          "Region": "West",
          "College": "Aditya College Of Architecture, Sarda Estate"
        },
        {
          "Region": "South",
          "College": "Agni School of Architecture and Design Excellence (ASADE)"
        },
        {
          "Region": "West",
          "College": "Akhil Bharatiya Maratha Shikshan Parishad’s Anantrao Pawar College Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "Al Salama Institute Of Architecture"
        },
        {
          "Region": "West",
          "College": "Allana College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Alpha Institute Of Architecture Studies"
        },
        {
          "Region": "North",
          "College": "Amity School of Architecture & Planning, Amity University Rajasthan \n"
        },
        {
          "Region": "North",
          "College": "Amity School Of Architecture & Planning, Amity University, Gurgaon"
        },
        {
          "Region": "West",
          "College": "Amity School of Architecture & Planning, Amity University, Madhya Pradesh"
        },
        {
          "Region": "North ",
          "College": "Amity School of Architecture & Planning, Amity University, Noida Campus Uttar Pradesh"
        },
        {
          "Region": "West",
          "College": "Amity School Of Architecture and Planning, Amity University Mumbai"
        },
        {
          "Region": "East",
          "College": "Amity School of Architecture and Planning, Amity University West Bengal"
        },
        {
          "Region": "North ",
          "College": "Amity School of Architecture and Planning, Amity University, Lucknow Campus, Uttar Pradesh "
        },
        {
          "Region": "East",
          "College": "Amity School Of Architecture and Planning, Raipur, Amity University Chhattisgarh"
        },
        {
          "Region": "North ",
          "College": "Anand College of Architecture"
        },
        {
          "Region": "South",
          "College": "Anand School of Architecture"
        },
        {
          "Region": "South",
          "College": "Angadi School Of Architecture \n"
        },
        {
          "Region": "North ",
          "College": "Ansal School of Architecture"
        },
        {
          "Region": "South",
          "College": "ANU College Of Architecture & Planning, Acharya Nagarjuna University "
        },
        {
          "Region": "North ",
          "College": "Apeejay Institute of Technology's School of Architecture & Planning "
        },
        {
          "Region": "North",
          "College": "APG School Of Architecture, A P Goyal Shimla University "
        },
        {
          "Region": "South",
          "College": "Ashoka School of Planning and Architecture"
        },
        {
          "Region": "West",
          "College": "Ashokrao Mane College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Asian School Of Architecture and Design Innovation (ASADI)"
        },
        {
          "Region": "West",
          "College": "Asmita College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Aurora’s Design Academy"
        },
        {
          "Region": "South",
          "College": "Aurora’s Design Institute"
        },
        {
          "Region": "South",
          "College": "Avani Institute Of Design"
        },
        {
          "Region": "East",
          "College": "Awadh College Of Architecture"
        },
        {
          "Region": "North ",
          "College": "Axis Institute of Architecture (AIA)"
        },
        {
          "Region": "West",
          "College": "Bagulamukhi College of Architecture & Planning"
        },
        {
          "Region": "West",
          "College": "Balwant Sheth School Of Architecture, SVKM’s NMIMS "
        },
        {
          "Region": "South",
          "College": "Bearys Enviro-Architecture Design School"
        },
        {
          "Region": "South",
          "College": "BGS School Of Architecture and Planning"
        },
        {
          "Region": "North",
          "College": "Bhagwan Mahaveer School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Bhagwan Mahavir College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Bharati Vidyapeeth University’s College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Bharati Vidyapeeth’s College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Bharatratna Dr. A. P. J. Abdul Kalam College Of Architecture"
        },
        {
          "Region": "East",
          "College": "Birla Institute Of Technology, International Centre, Ras Al Khaimah (Study Centre)"
        },
        {
          "Region": "East",
          "College": "Birla Institute Of Technology, Mesra, Ranchi"
        },
        {
          "Region": "South",
          "College": "Bishop Jerome School Of Architecture & Design"
        },
        {
          "Region": "West",
          "College": "BKPS College Of Architecture"
        },
        {
          "Region": "South",
          "College": "BMS College Of Architecture"
        },
        {
          "Region": "South",
          "College": "BMS School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Brindavan College Of Architecture"
        },
        {
          "Region": "North",
          "College": "Buddha Institute of Architecture & Town Planning"
        },
        {
          "Region": "North",
          "College": "Budha College Of Architecture"
        },
        {
          "Region": "West",
          "College": "C. T. E. S. College Of Architecture"
        },
        {
          "Region": "South",
          "College": "C.A.R.E. School of Architecture"
        },
        {
          "Region": "South",
          "College": "CAAD-Chennai Academy of Architecture and Design"
        },
        {
          "Region": "South",
          "College": "Capital College of Architecture"
        },
        {
          "Region": "North",
          "College": "CCLS College Of Architecture & Design "
        },
        {
          "Region": "North ",
          "College": "Centre for Architecture, Brahmanand Group of Institutions "
        },
        {
          "Region": "North",
          "College": "Chandigarh College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Chettinad School of Architecture"
        },
        {
          "Region": "North",
          "College": "Chitkara School of Planning & Architecture"
        },
        {
          "Region": "North",
          "College": "College of Architecture & Design, Mody University of Science and Technology"
        },
        {
          "Region": "South",
          "College": "College Of Architecture Trivandrum"
        },
        {
          "Region": "West",
          "College": "College of Architecture, Dr. A. P. J. Abdul Kalam University Indore"
        },
        {
          "Region": "North",
          "College": "College of Architecture, I.E.T.Bhaddal"
        },
        {
          "Region": "North ",
          "College": "College of Architecture, IIMT University"
        },
        {
          "Region": "North ",
          "College": "College of Architecture, Invertis University"
        },
        {
          "Region": "North ",
          "College": "College of Architecture, Moradabad Educational Trust "
        },
        {
          "Region": "West",
          "College": "College Of Architecture, Sardar Vallabhai Patel Institute Of Technology "
        },
        {
          "Region": "West",
          "College": "College of Architecture, SDPS Women’s College "
        },
        {
          "Region": "North",
          "College": "College Of Architecture, Vastu Kala Academy"
        },
        {
          "Region": "South",
          "College": "College Of Engineering, Andhra University"
        },
        {
          "Region": "South",
          "College": "Crescent School of Architecture"
        },
        {
          "Region": "North",
          "College": "CT Institute of Architecture and Planning"
        },
        {
          "Region": "South",
          "College": "D. C. School Of Architecture and Design \n"
        },
        {
          "Region": "West",
          "College": "D. Y. Patil College Of Architecture, Kolhapur"
        },
        {
          "Region": "West",
          "College": "D. Y. Patil College Of Engineering & Technology \n"
        },
        {
          "Region": "West",
          "College": "D. Y. Patil School Of Architecture \n"
        },
        {
          "Region": "West",
          "College": "D. Y. Patil SchoolOf Architecture \n"
        },
        {
          "Region": "West",
          "College": "D.C. Patel School Of Architecture, Arvindbhai Patel Institute Of Environmental Design "
        },
        {
          "Region": "South",
          "College": "DA Vinci School of Design and Architecture"
        },
        {
          "Region": "North ",
          "College": "Dayalbagh Educational Institute"
        },
        {
          "Region": "West",
          "College": "Dayanand College Of Architecture, Dayanand Education Society"
        },
        {
          "Region": "South",
          "College": "Dayananda Sagar School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Deccan School of Planning & Architecture"
        },
        {
          "Region": "North",
          "College": "Delhi Global Institute Of Architecture"
        },
        {
          "Region": "North",
          "College": "Delhi Institute Of Architecture & Planning"
        },
        {
          "Region": "North",
          "College": "Department of Architecture & Planning, Indian Institute of Technology Roorkee"
        },
        {
          "Region": "East",
          "College": "Department of Architecture & Planning, Indira Gandhi Institute of Technology \n"
        },
        {
          "Region": "North",
          "College": "Department of Architecture & Town Planning, M.B.M.Engineering College, Faculty of Engineering & Architecture, Jai Narain Vyas University "
        },
        {
          "Region": "North",
          "College": "Department of Architecture and Planning, Malviya National Institute of Technology "
        },
        {
          "Region": "West",
          "College": "Department Of Architecture and Planning, Visvesvaraya National Institute Of Technology"
        },
        {
          "Region": "South",
          "College": "Department Of Architecture, BLDE Association's V.P. Dr. P. G. Halakatti College Of Engineering & Technology"
        },
        {
          "Region": "South",
          "College": "Department Of Architecture, College Of Engineering Trivandrum"
        },
        {
          "Region": "North",
          "College": "Department Of Architecture, Deenbandhu Chhotu Ram University Of Science & Technology"
        },
        {
          "Region": "South",
          "College": "Department Of Architecture, Faculty Of Engineering & Technology"
        },
        {
          "Region": "North",
          "College": "Department of Architecture, Guru Nanak Dev University"
        },
        {
          "Region": "North",
          "College": "Department of Architecture, I.K.Gujral Punjab Technical University, Khunnimajra "
        },
        {
          "Region": "North",
          "College": "Department Of Architecture, Indira Gandhi Delhi Technical University for Women"
        },
        {
          "Region": "East",
          "College": "Department Of Architecture, ITM University "
        },
        {
          "Region": "East",
          "College": "Department of Architecture, Jadavpur University"
        },
        {
          "Region": "South",
          "College": "Department Of Architecture, K.L.E.F.University"
        },
        {
          "Region": "West",
          "College": "Department Of Architecture, M. S. University Of Baroda"
        },
        {
          "Region": "East",
          "College": "Department Of Architecture, National Institute Of Technology Bihar"
        },
        {
          "Region": "South",
          "College": "Department Of Architecture, National Institute Of Technology Calicut "
        },
        {
          "Region": "East",
          "College": "Department Of Architecture, National Institute Of Technology Chattisgarh"
        },
        {
          "Region": "North",
          "College": "Department Of Architecture, National Institute Of Technology Hamirpur"
        },
        {
          "Region": "South",
          "College": "Department of Architecture, National Institute of Technology Trichy"
        },
        {
          "Region": "South",
          "College": "Department of Architecture, School of Building & Environment, Sathyabama University"
        },
        {
          "Region": "East",
          "College": "Department of Architecture, School of Technology, North-Eastern Hill University"
        },
        {
          "Region": "South",
          "College": "Department of Architecture, Thiagarajar College of Engineering, Thiruparankundram"
        },
        {
          "Region": "East",
          "College": "Department of Architecture, Veer Surendra Sai University of Technology"
        },
        {
          "Region": "North ",
          "College": "Department of Architecture, Zakir Hussain College of Engineering & Technology"
        },
        {
          "Region": "West",
          "College": "Department of Architecture. Madhav Institute of Technology & Science"
        },
        {
          "Region": "East",
          "College": "Department of Planning and Architecture, Mizoram University, Tanhril"
        },
        {
          "Region": "East",
          "College": "Dept. of Architecture, Town and Regional Planning, Indian Institute of Engineering Science and Technology (IIEST) Shibpur"
        },
        {
          "Region": "South",
          "College": "Designed Environment Academy & Research Institute - DEAR Institute "
        },
        {
          "Region": "North",
          "College": "Dev Bhoomi School of Architecture"
        },
        {
          "Region": "South",
          "College": "Devaki Amma’s Guruvayurappan College Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "Dhanalakshmi Srinivasan School of Architecture, Perambalur"
        },
        {
          "Region": "South",
          "College": "Dhanalakshmi Srinivasan School of Architecture, Trichy"
        },
        {
          "Region": "East",
          "College": "Dignity College Of Architecture"
        },
        {
          "Region": "North",
          "College": "DIT-Faculty of Architecture, Dehradun Institute of Technology"
        },
        {
          "Region": "West",
          "College": "Dr Manoj A Shete College Of Architecture Kasara Tal Shahpu"
        },
        {
          "Region": "West",
          "College": "Dr. Baliram Hiray College Of Architecture \n"
        },
        {
          "Region": "West",
          "College": "Dr. D Y Patil School Of Architecture \n"
        },
        {
          "Region": "West",
          "College": "Dr. J. J. Magdum College of Architecture \n"
        },
        {
          "Region": "South",
          "College": "East West School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Eranad Knowledge City College Of Architecture"
        },
        {
          "Region": "South",
          "College": "EXCEL College of Architecture and Planning"
        },
        {
          "Region": "North",
          "College": "Faculty Of Architecture & Ekistics, Jamia Millia Islamia"
        },
        {
          "Region": "North",
          "College": "Faculty Of Architecture & Planning, Jagan Nath University"
        },
        {
          "Region": "North",
          "College": "Faculty of Architecture & Planning, Vivekananda Global University "
        },
        {
          "Region": "East",
          "College": "Faculty of Architecture & Regional Planning, Indian Institute of Technology Kharagpur"
        },
        {
          "Region": "North",
          "College": "Faculty Of Architecture & Town Planning, P. D. M University"
        },
        {
          "Region": "East",
          "College": "Faculty of Architecture and Design, College of Engineering & Technology, Biju Patnaik University of Technology Techno Campus"
        },
        {
          "Region": "North ",
          "College": "Faculty of Architecture and Town Planning, Raja Balwant Singh Engineering Technical Campus Bichpuri"
        },
        {
          "Region": "West",
          "College": "Faculty Of Architecture Centre for Environmental Planning & Technology University (CEPT University) \n"
        },
        {
          "Region": "South",
          "College": "Faculty of Architecture, Dr. M.G.R. Educational and Research Institute University"
        },
        {
          "Region": "North",
          "College": "Faculty of Architecture, Dr.A.P.J.Abdul Kalam Technical University \n"
        },
        {
          "Region": "North",
          "College": "Faculty of Architecture, Himgiri Zee University "
        },
        {
          "Region": "North ",
          "College": "Faculty of Architecture, Integral University"
        },
        {
          "Region": "North",
          "College": "Faculty of Architecture, Jagannath University Jaipur"
        },
        {
          "Region": "South",
          "College": "Faculty of Architecture, Karpagam University "
        },
        {
          "Region": "West",
          "College": "Faculty Of Architecture, Parul Institute Of Architecture and Research, Parul University"
        },
        {
          "Region": "South",
          "College": "Faculty Of Architecture, PES University "
        },
        {
          "Region": "West",
          "College": "Faculty of Architecture, RKDF University"
        },
        {
          "Region": "West",
          "College": "Faculty Of Architecture, Sarvajanik College Of Engineering & Technology"
        },
        {
          "Region": "East",
          "College": "Faculty of Architecture, Sri Sri University"
        },
        {
          "Region": "North",
          "College": "Faculty Of Planning and Architecture, Manav Rachna International University"
        },
        {
          "Region": "West",
          "College": "Flora College Of Architecture"
        },
        {
          "Region": "North ",
          "College": "Forth Dimension College of Architecture"
        },
        {
          "Region": "North",
          "College": "Ganga Institute Of Architecture & Town Planning"
        },
        {
          "Region": "North",
          "College": "Gateway College Of Architecture & Design"
        },
        {
          "Region": "South",
          "College": "GITAM School of Architecture, Hyderabad"
        },
        {
          "Region": "South",
          "College": "Global Institute Of Architecture"
        },
        {
          "Region": "North",
          "College": "GNDEC School of Architecture"
        },
        {
          "Region": "West",
          "College": "Goa College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Gokul College Of Architecture & Design"
        },
        {
          "Region": "South",
          "College": "Gopalan School Of Architecture and Planning"
        },
        {
          "Region": "North",
          "College": "Govt. M.A.M College, Jammu"
        },
        {
          "Region": "West",
          "College": "Grow More School Of Architecture"
        },
        {
          "Region": "East",
          "College": "Guwahati College Of Architecture"
        },
        {
          "Region": "North",
          "College": "Hindu College Of Design, Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "Hindusthan School of Architecture"
        },
        {
          "Region": "West",
          "College": "Hitkarni College of Architecture & Town Planning"
        },
        {
          "Region": "South",
          "College": "Holy Crescent College Of Architecture"
        },
        {
          "Region": "West",
          "College": "I.P.S.Academy's School of Architecture"
        },
        {
          "Region": "South",
          "College": "ICFAI School of Architecture"
        },
        {
          "Region": "North",
          "College": "ICL Institute Of Architecture and Town Planning"
        },
        {
          "Region": "West",
          "College": "Ideal College Of Architecture"
        },
        {
          "Region": "West",
          "College": "IDEAL Institute Of Architecture"
        },
        {
          "Region": "West",
          "College": "IDEAS - Institute Of Design Education & Architecture Studies"
        },
        {
          "Region": "South",
          "College": "IES College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Immanuel Arasar College of Architecture"
        },
        {
          "Region": "South",
          "College": "IMPACT School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Indala School Of Architecture "
        },
        {
          "Region": "West",
          "College": "Indian Education Society’s College Of Architecture"
        },
        {
          "Region": "North",
          "College": "Indo Global College of Architecture"
        },
        {
          "Region": "West",
          "College": "Institute Of Architecture & Planning\n, Nirma University"
        },
        {
          "Region": "North ",
          "College": "Institute of Architecture & Planning Shri Ramswaroop Memorial University"
        },
        {
          "Region": "North ",
          "College": "Institute of Architecture and Town Planning, Bundelkhand University"
        },
        {
          "Region": "West",
          "College": "Institute Of Architecture, Ganpat University"
        },
        {
          "Region": "West",
          "College": "Institute Of Architecture, Hemchandracharya North Gujarat University "
        },
        {
          "Region": "West",
          "College": "Institute of Architecture, Sage University"
        },
        {
          "Region": "West",
          "College": "Institute Of Design, Environment & Architecture, Indus University"
        },
        {
          "Region": "North ",
          "College": "ITM School of Architecture & Town Planning"
        },
        {
          "Region": "West",
          "College": "ITM School Of Architecture Art and Design"
        },
        {
          "Region": "South",
          "College": "J.B.R. Architecture College"
        },
        {
          "Region": "South",
          "College": "J.K.K.Munirajah School of Architecture"
        },
        {
          "Region": "West",
          "College": "Jai Shri Siddhivinayak Foundation Trust’s B. R. Harne College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Jawahar School of Architecture, Planning and Design"
        },
        {
          "Region": "South",
          "College": "Jaya School of Architecture"
        },
        {
          "Region": "West",
          "College": "Jhulelal Institute Of Architecture"
        },
        {
          "Region": "North",
          "College": "Jindal School Of Art and Architecture, O. P. Jindal Global University"
        },
        {
          "Region": "South",
          "College": "JK College of Architecture"
        },
        {
          "Region": "South",
          "College": "K. S. School Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "Kalasalingam School of Architecture"
        },
        {
          "Region": "West",
          "College": "Kalol Institute Of Architecture & Design"
        },
        {
          "Region": "West",
          "College": "Kamla Raheja Vidyanidhi Institute for Architecture & Environmental Studies"
        },
        {
          "Region": "North ",
          "College": "Khandelwal College of Architecture and Design"
        },
        {
          "Region": "South",
          "College": "KMCT College Of Architecture, Kallanthode"
        },
        {
          "Region": "South",
          "College": "KMCT College Of Architecture, Manassery"
        },
        {
          "Region": "South",
          "College": "KMEA College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Kongu School of Architecture"
        },
        {
          "Region": "West",
          "College": "L. J. School Of Architecture"
        },
        {
          "Region": "West",
          "College": "L. S. Raheja School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Late Shri Bapuraoji Deshmukh Degree College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Laxmi Institute Of Architecture"
        },
        {
          "Region": "North",
          "College": "Lingaya’s University’s School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Lokmanya Tilak Institute Of Architecture & Design"
        },
        {
          "Region": "North",
          "College": "Lovely School of Architecture & Design, Lovely Professional University"
        },
        {
          "Region": "South",
          "College": "M. R. K. College Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "M.A.M. School of Architecture"
        },
        {
          "Region": "South",
          "College": "Madha School of Architecture"
        },
        {
          "Region": "South",
          "College": "Maestro School Of Planning and Architecture"
        },
        {
          "Region": "South",
          "College": "Maestro School of Planning and Architecture, Hyderabad"
        },
        {
          "Region": "West",
          "College": "Maharshi KarveStree Shikshan Samstha’s Dr.Bhanuben Nanavati\nCollege Of Architecture for Women \n(BNCA)"
        },
        {
          "Region": "West",
          "College": "Mahatma Education Society’s Pillai’s HOC College Of Architecture, Rasyani"
        },
        {
          "Region": "West",
          "College": "Mahatma Education Society’s Pillais’ College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Mahavir Swami College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Malik Sandal Institute Of Art & Architecture \n"
        },
        {
          "Region": "South",
          "College": "Mangalam School Of Architecture and Planning "
        },
        {
          "Region": "South",
          "College": "Manipal School Of Architecture & Planning, Manipal University "
        },
        {
          "Region": "West",
          "College": "Marathwada Mitra Mandal's College Of Architecture \n"
        },
        {
          "Region": "West",
          "College": "Marathwada Mitra Mandals Institute Of Environmental & Designs College Of Architecture "
        },
        {
          "Region": "South",
          "College": "MARG Institute of Design and Architecture Swarnabhoomi (MIDAS) \n"
        },
        {
          "Region": "South",
          "College": "Marian College Of Architecture & Planning"
        },
        {
          "Region": "West",
          "College": "Marwadi Education Foundation’s Group Of Institutions, Faculty Of Architecture"
        },
        {
          "Region": "West",
          "College": "Maulana Azad National Institute of Technology, Bhopal"
        },
        {
          "Region": "North",
          "College": "MBS School Of Planning and Architecture"
        },
        {
          "Region": "South",
          "College": "McGan’s Ooty School of Architecture"
        },
        {
          "Region": "South",
          "College": "MEA College Of Architecture, MEA Engineering College"
        },
        {
          "Region": "South",
          "College": "MEASI Academy of Architecture"
        },
        {
          "Region": "South",
          "College": "MES College Of Architecture"
        },
        {
          "Region": "West",
          "College": "MET’s School Of Architecture and Interior Design"
        },
        {
          "Region": "South",
          "College": "Misrimal Navajee Munoth Jain School of Architecture"
        },
        {
          "Region": "West",
          "College": "MIT Art, Design & Technology University Pune’s School Of Architecture"
        },
        {
          "Region": "North",
          "College": "MM School Of Architecture, Maharishi Markandeshwar University"
        },
        {
          "Region": "South",
          "College": "MMES Academy of Architecture"
        },
        {
          "Region": "South",
          "College": "Mohamed Sathak A.J. Academy of Architecture, Kancheepuram"
        },
        {
          "Region": "North ",
          "College": "Monad School of Architecture & Planning, Monad University"
        },
        {
          "Region": "West",
          "College": "Mudra Takshashila Institute Of Design & Architecture"
        },
        {
          "Region": "West",
          "College": "MVP Samaj’s College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Mysore School Of Architecture"
        },
        {
          "Region": "South",
          "College": "N. R. School of Architecture"
        },
        {
          "Region": "North ",
          "College": "Naraina School of Planning & Architecture"
        },
        {
          "Region": "East",
          "College": "National Institute of Technology, Rourkela"
        },
        {
          "Region": "South",
          "College": "Nehru College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Nehru School of Architecture"
        },
        {
          "Region": "North",
          "College": "NIMS School of Architecture & Planning, NIMS University"
        },
        {
          "Region": "South",
          "College": "Nitte Institute Of Architecture"
        },
        {
          "Region": "South",
          "College": "Nitte School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Nizar Rahim and Mark School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Noble Architecture College"
        },
        {
          "Region": "East",
          "College": "Om Dayal School of Architecture"
        },
        {
          "Region": "North",
          "College": "Om Institute Of Architecture & Design"
        },
        {
          "Region": "West",
          "College": "Oyster College Of Architecture"
        },
        {
          "Region": "West",
          "College": "P P Savani School Of Architecture"
        },
        {
          "Region": "North",
          "College": "P. M. College Of Architecture"
        },
        {
          "Region": "West",
          "College": "P.R.Patil College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Padmashree Dr. D.Y.Patil College Of Architecture "
        },
        {
          "Region": "South",
          "College": "Papni School of Architecture"
        },
        {
          "Region": "South",
          "College": "Park Institute of Architecture"
        },
        {
          "Region": "East",
          "College": "Piloo-Mody College of Architecture"
        },
        {
          "Region": "South",
          "College": "Poojya Dr. Shivakumar Swamiji School Of Architecture "
        },
        {
          "Region": "West",
          "College": "Pravara Rural College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Pravara Rural Education Society’s, College Of Architecture "
        },
        {
          "Region": "South",
          "College": "Prime College of Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "Prime Nest College of Architecture and Planning"
        },
        {
          "Region": "West",
          "College": "Priyadarshini Institute Of Architecture & Design Studies"
        },
        {
          "Region": "West",
          "College": "Pune District Education Association’s College Of Architecture"
        },
        {
          "Region": "North ",
          "College": "Purvanchal Institute of Architecture & Design"
        },
        {
          "Region": "South",
          "College": "R. R. School Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "R. V. College Of Architecture (RVCA) \n"
        },
        {
          "Region": "South",
          "College": "R.V.S. School of Architecture, Dindigul"
        },
        {
          "Region": "South",
          "College": "R.V.S. School of Architecture, Kumaran Kottam Campus"
        },
        {
          "Region": "West",
          "College": "Radhikatai Pandav Institute Of Architecture"
        },
        {
          "Region": "South",
          "College": "Rajalakshmi School of Architecture"
        },
        {
          "Region": "North",
          "College": "Rajiv Gandhi Government Engineering College, Kangra"
        },
        {
          "Region": "West",
          "College": "Raman Bhakta School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Ramesh Phirodia College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Ranganathan Architecture College"
        },
        {
          "Region": "East",
          "College": "Rani Rashmoni School of Architecture"
        },
        {
          "Region": "South",
          "College": "Rathinam School of Architecture"
        },
        {
          "Region": "North",
          "College": "RIMT College of Architecture"
        },
        {
          "Region": "West",
          "College": "Rizvi College Of Architecture"
        },
        {
          "Region": "South",
          "College": "RNS School Of Architecture"
        },
        {
          "Region": "East",
          "College": "Royal School Of Architecture"
        },
        {
          "Region": "South",
          "College": "RVS KVK School of Architecture, Trichy"
        },
        {
          "Region": "South",
          "College": "RVS Padmavathy School of Architecture"
        },
        {
          "Region": "West",
          "College": "S. B. Patil College Of Architecture & Design"
        },
        {
          "Region": "North",
          "College": "Sai School of Architecture"
        },
        {
          "Region": "West",
          "College": "Sal School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Salem School of Architecture"
        },
        {
          "Region": "West",
          "College": "Samyak Sankalpa College Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "San Academy of Architecture"
        },
        {
          "Region": "North ",
          "College": "Sanskar College of Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "Sasi Creative School of Architecture"
        },
        {
          "Region": "West",
          "College": "Satish Misal Educational Foundation’s BRICK School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Saveetha College of Architecture and Design"
        },
        {
          "Region": "West",
          "College": "School of Architecture & Design, ITM University Gwalior"
        },
        {
          "Region": "South",
          "College": "School of Architecture & Interior Design, SRM Institute of Science and Technology "
        },
        {
          "Region": "North",
          "College": "School Of Architecture & Landscape Design, Faculty Of Engineering, Shri Mata Vaishno Devi University "
        },
        {
          "Region": "South",
          "College": "School of Architecture & Planning, Anna University"
        },
        {
          "Region": "North ",
          "College": "School of Architecture & Planning, BabuBanarasi Das University "
        },
        {
          "Region": "North",
          "College": "School Of Architecture & Planning, G. D. Goenka University "
        },
        {
          "Region": "North",
          "College": "School Of Architecture & Planning, K.R.Mangalam University \n"
        },
        {
          "Region": "North ",
          "College": "School of Architecture & Planning, Sharda University"
        },
        {
          "Region": "North ",
          "College": "School of Architecture & Town Planning, R.R.Institute of Modern Technology \n"
        },
        {
          "Region": "North",
          "College": "School of Architecture and Design, Manipal University, Jaipur"
        },
        {
          "Region": "South",
          "College": "School of Architecture and Planning, Aarupadai Veedu Institute of Technology"
        },
        {
          "Region": "North",
          "College": "School of Architecture and Planning, Graphic Era Hill University "
        },
        {
          "Region": "East",
          "College": "School of Architecture and Planning, KIIT University"
        },
        {
          "Region": "South",
          "College": "School of Architecture and Planning, Periyar Maniammai University"
        },
        {
          "Region": "North ",
          "College": "School of Architecture and Regional Planning, Gautam Buddha University"
        },
        {
          "Region": "South",
          "College": "School of Architecture, Adhiyamaan College of Engineering "
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Anant National University "
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Anjuman-I-Islam’s Kalsekar Technical Campus "
        },
        {
          "Region": "North",
          "College": "School of Architecture, Apex Group of Institution "
        },
        {
          "Region": "South",
          "College": "School of Architecture, Arulmigu Meenakshi Amman College of Engineering, Vadamavanda"
        },
        {
          "Region": "South",
          "College": "School of Architecture, Bharat University "
        },
        {
          "Region": "North",
          "College": "School of Architecture, Central University of Rajasthan "
        },
        {
          "Region": "West",
          "College": "School of Architecture, Chhatrapati Shivaji Maharaj University "
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Christ University "
        },
        {
          "Region": "South",
          "College": "School Of Architecture, CMR University"
        },
        {
          "Region": "South",
          "College": "School of Architecture, Coimbatore Institute of Engineering and Technology"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, College Of Engineering & Technology, Near Shri Shivaji Park \n"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, College Of Engineering and Technology Payyanur"
        },
        {
          "Region": "South",
          "College": "School of Architecture, CSI Institute of Technology "
        },
        {
          "Region": "North",
          "College": "School of Architecture, CT University"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, D Y Patil Deemed to be University"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Dayananda Sagar Academy Of Technology and Management"
        },
        {
          "Region": "North ",
          "College": "School of Architecture, Delhi Technical Campus"
        },
        {
          "Region": "North",
          "College": "School of Architecture, Dr. K. N. Modi University \n"
        },
        {
          "Region": "North ",
          "College": "School of Architecture, G.L.Bajaj Group of Institutions"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, G.S.Mandal's Marathwada Institute Of Technology"
        },
        {
          "Region": "North ",
          "College": "School of Architecture, Galgotias University"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Gandhi Institute Of Technology and Management, (GITAM)"
        },
        {
          "Region": "North",
          "College": "School of Architecture, GianiZail Singh Campus College of Engineering &Technology"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Government Engineering College Thrissur"
        },
        {
          "Region": "South",
          "College": "School of Architecture, Hindustan Institute of Technology and Science "
        },
        {
          "Region": "South",
          "College": "School Of Architecture, HMS Institute Of Technology"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Jawahar Lal Nehru Engineering College"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Karnataka Law Society's Gogte Institute Of Technology"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Kavikulguru Institute Of Technology & Science"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, KLE Technological University"
        },
        {
          "Region": "West",
          "College": "School of Architecture, LNCT University \n"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Manoharbhai Patel Institute Of Engineering & Technology"
        },
        {
          "Region": "South",
          "College": "School of Architecture, Meenakshi College of Engineering "
        },
        {
          "Region": "South",
          "College": "School Of Architecture, MES College Of Engineering "
        },
        {
          "Region": "South",
          "College": "School of Architecture, Mohammed Sathak Engineering College Campus"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Mookambika Technical Campus "
        },
        {
          "Region": "South",
          "College": "School Of Architecture, MS Ramaiah Institute Of Technology"
        },
        {
          "Region": "North ",
          "College": "School of Architecture, Noida International University "
        },
        {
          "Region": "East",
          "College": "School of Architecture, Planning & Design, Centurian University of Technology & Management "
        },
        {
          "Region": "South",
          "College": "School of Architecture, PRIST University"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Rajiv Gandhi Institute Of Technology "
        },
        {
          "Region": "West",
          "College": "School of Architecture, Rajiv Gandhi Proudyogiki Vishwavidyalaya"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Reva University"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Sanjay Ghodawat University, Kolhapur"
        },
        {
          "Region": "North",
          "College": "School of Architecture, Shaheed Bhagat Singh State Technical Campus"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Siddaganga Institute Of Technology"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, Srinivas Institute Of Technology"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Symbiosis Skills and Open University, Pune"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, TKM College Of Engineering"
        },
        {
          "Region": "South",
          "College": "School Of Architecture, University Visvesvaraya College Of Engineering, Bangalore University"
        },
        {
          "Region": "West",
          "College": "School Of Architecture, Vadodara Design Academy "
        },
        {
          "Region": "South",
          "College": "School of Architecture, VIT University"
        },
        {
          "Region": "South",
          "College": "School of Architecture,Sri ManakulaVinayagar Engineering College "
        },
        {
          "Region": "South",
          "College": "School Of Design and Architecture, Manipal University - Dubai Campus (Study Centre)"
        },
        {
          "Region": "West",
          "College": "School Of Design and Architecture, Navrachana University"
        },
        {
          "Region": "West",
          "College": "School Of Environment and Architecture"
        },
        {
          "Region": "South",
          "College": "School of Environment Architecture and Design (SEAD), SRM University, Ramapuram Campus "
        },
        {
          "Region": "South",
          "College": "School of Planning & Architecture (SPA), Jawaharlal Nehru Institute of Advanced Studies (JNIAS)"
        },
        {
          "Region": "South",
          "College": "School of Planning & Architecture Jawaharlal Nehru Architecture and Fine Arts University (JNA&FAU)"
        },
        {
          "Region": "West",
          "College": "School of Planning & Architecture, Bhopal"
        },
        {
          "Region": "North",
          "College": "School of Planning & Architecture, Poornima University"
        },
        {
          "Region": "North",
          "College": "School Of Planning and Architecture, Delhi"
        },
        {
          "Region": "South",
          "College": "School Of Planning and Architecture, University Of Mysore"
        },
        {
          "Region": "South",
          "College": "School Of Planning and Architecture, Vijayawada "
        },
        {
          "Region": "South",
          "College": "SCMS School Of Architecture"
        },
        {
          "Region": "East",
          "College": "SGI School of Architecture"
        },
        {
          "Region": "West",
          "College": "Shantaben Manubhai Patel School Of Studies and Research in Architecture and Interior Design \n"
        },
        {
          "Region": "West",
          "College": "Shree Chanakya Education Society’s Indira College Of Architecture and Design"
        },
        {
          "Region": "West",
          "College": "Shri Datta Meghe College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Shri Gijubhai Chhaganbhai Patel Institute Of Architecture, Interior Design and Fine Arts, Veer Narmad South Gujarat University"
        },
        {
          "Region": "West",
          "College": "Shri Prince Shivaji Maratha Boarding House's College Of Architecture"
        },
        {
          "Region": "North ",
          "College": "Shri Ram School of Architecture"
        },
        {
          "Region": "West",
          "College": "Shri Shivaji Maratha Society’s College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Shri SiddeshwarShikshan Mandal’s College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Shri V.B.Patil Trust’s Appasaheb Birnale College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Shri Vaishnav Institute of Architecture"
        },
        {
          "Region": "West",
          "College": "Shrikrishna Educational & Cultural Mandal’s, College Of Architecture "
        },
        {
          "Region": "West",
          "College": "Siddant College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Sigma College of Architecture"
        },
        {
          "Region": "West",
          "College": "Sinhgad College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Sipna School Of Planning and Architecture"
        },
        {
          "Region": "West",
          "College": "Sir J. J. College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Sir M V School Of Architecture"
        },
        {
          "Region": "South",
          "College": "SJB School Of Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "Skandha School of Architecture"
        },
        {
          "Region": "West",
          "College": "Smt. K. L. Tiwari College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Smt. Kashibai Navale College Of Architecture \n"
        },
        {
          "Region": "West",
          "College": "Smt. Manoramabai Mundle, College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Smt. Premalati Chavan College Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "Sneha College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Solapur Education Society’s College Of Architecture "
        },
        {
          "Region": "North",
          "College": "South Point School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Sree Sastha School of Architecture and Planning"
        },
        {
          "Region": "South",
          "College": "Sri Venkateswara College of Architecture"
        },
        {
          "Region": "West",
          "College": "St. Wilfred’s Institute Of Architecture \n"
        },
        {
          "Region": "North",
          "College": "St. Wilfred’s Institute of Architecture, Ajmer"
        },
        {
          "Region": "South",
          "College": "St.Peter’s College of Engineering and Technology, Avadi "
        },
        {
          "Region": "South",
          "College": "St.Peter’s School of Architecture, Tonakela"
        },
        {
          "Region": "North",
          "College": "State Institute Of Urban Planning & Architecture"
        },
        {
          "Region": "North ",
          "College": "Sunder Deep College of Architecture"
        },
        {
          "Region": "South",
          "College": "Surya School of Architecture"
        },
        {
          "Region": "North",
          "College": "Sushant School Of Art & Architecture, Ansal University"
        },
        {
          "Region": "South",
          "College": "SVS School of Architecture"
        },
        {
          "Region": "West",
          "College": "Symbiosis School Of Planning,Architecture and Design \n"
        },
        {
          "Region": "South",
          "College": "Talent Institute Of Architecture (TIBA)"
        },
        {
          "Region": "South",
          "College": "Tamil Nadu School of Architecture"
        },
        {
          "Region": "West",
          "College": "Tatyaasaheb Kore College Of Architecture, Warananagar"
        },
        {
          "Region": "East",
          "College": "Techno India University School of Architecture"
        },
        {
          "Region": "North ",
          "College": "Teerthanker Mahaveer College of Architecture"
        },
        {
          "Region": "West",
          "College": "Thakur School Of Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "The Oxford School Of Architecture, The Oxford College Of Engineering "
        },
        {
          "Region": "South",
          "College": "Thejus College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Tips School of Architecture"
        },
        {
          "Region": "South",
          "College": "TKM School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Trinity College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Tulsiramji Gaikwad-Patil College Of Architecture"
        },
        {
          "Region": "North",
          "College": "University Institute of Architecture"
        },
        {
          "Region": "North",
          "College": "University School Of Architecture & Planning, Guru Gobind Singh Indraprastha University "
        },
        {
          "Region": "South",
          "College": "V.P.M.M. College of Architecture for Women"
        },
        {
          "Region": "West",
          "College": "Vadodara Institute Of Architecture"
        },
        {
          "Region": "South",
          "College": "Vaishnavi School of Architecture & Planning"
        },
        {
          "Region": "South",
          "College": "Vaishnavi School Of Architecture and Planning"
        },
        {
          "Region": "South",
          "College": "Varaha College Of Architecture & Planning"
        },
        {
          "Region": "West",
          "College": "Vasantdada Patil Pratishthans’s Manoharphalke College Of Architecture \n"
        },
        {
          "Region": "South",
          "College": "Vedavyasa College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Venus Institute Of Design & Architecture"
        },
        {
          "Region": "West",
          "College": "Vidya Pratishthan’s School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Vidya Pratisthan’sIndapur College Of Architecture"
        },
        {
          "Region": "West",
          "College": "Vidya Vardhan’s Institute Of Design Environment and Architecture "
        },
        {
          "Region": "West",
          "College": "Vidyamandir College Of Architecture For Women"
        },
        {
          "Region": "West",
          "College": "Vishwakarma University School of Architecture and Planning, Vishwakarma University"
        },
        {
          "Region": "West",
          "College": "Vishwaniketan’s College Of Architecture, Arts and Design"
        },
        {
          "Region": "West",
          "College": "VIVA School Of Architecture"
        },
        {
          "Region": "West",
          "College": "Vivekanand Education Society College Of Architecture "
        },
        {
          "Region": "West",
          "College": "Vivekanand Institute Of Technology’s Padmabhushan Dr. Vasantdada Patil College Of Architecture"
        },
        {
          "Region": "South",
          "College": "Vivekanandhaa College of Architecture for Women"
        },
        {
          "Region": "West",
          "College": "Vyavasay Vidya Pratishthan's Indubhai Parekh School Of Architecture"
        },
        {
          "Region": "South",
          "College": "Wadiyar Centre for Architecture \n"
        },
        {
          "Region": "West",
          "College": "Walwa Taluka Education Society’s Shri S.D.Patil College Of Architecture"
        },
        {
          "Region": "North",
          "College": "World School Of Planning and Architecture"
        },
        {
          "Region": "South",
          "College": "Woxsen School of Architecture"
        },
        {
          "Region": "West",
          "College": "Yashoda College Of Architecture Satara"
        }
       ],
      // archUniversities: [
      //   'Guwahati College Of Architecture',
      //   'Royal School Of Architecture',
      //   'Department Of Architecture, National Institute Of Technology Bihar',
      //   'Department Of Architecture, National Institute Of Technology Chattisgarh',
      //   'Dignity College Of Architecture',
      //   'Amity School Of Architecture and Planning, Raipur, Amity University Chhattisgarh',
      //   'Department Of Architecture, ITM University ',
      //   'Chandigarh College Of Architecture',
      //   'Birla Institute Of Technology, Mesra, Ranchi',
      //   'Birla Institute Of Technology, International Centre, Ras Al Khaimah (Study Centre)',
      //   'Awadh College Of Architecture',
      //   'Department of Architecture, School of Technology, North-Eastern Hill University',
      //   'Department of Planning and Architecture, Mizoram University, Tanhril',
      //   'Faculty of Architecture and Design, College of Engineering & Technology, Biju Patnaik University of Technology Techno Campus',
      //   'Piloo-Mody College of Architecture',
      //   'School of Architecture and Planning, KIIT University',
      //   'School of Architecture, Planning & Design, Centurian University of Technology & Management ',
      //   'SGI School of Architecture',
      //   'National Institute of Technology, Rourkela',
      //   'Faculty of Architecture, Sri Sri University',
      //   'Department of Architecture & Planning, Indira Gandhi Institute of Technology ',
      //   'Department of Architecture, Veer Surendra Sai University of Technology',
      //   'Dept. of Architecture, Town and Regional Planning, Indian Institute of Engineering Science and Technology (IIEST) Shibpur',
      //   'Faculty of Architecture & Regional Planning, Indian Institute of Technology Kharagpur',
      //   'Department of Architecture, Jadavpur University',
      //   'Rani Rashmoni School of Architecture',
      //   'Om Dayal School of Architecture',
      //   'Techno India University School of Architecture',
      //   'Amity School of Architecture and Planning, Amity University West Bengal',
      //   'School Of Planning and Architecture, Delhi',
      //   'College Of Architecture, Vastu Kala Academy',
      //   'Faculty Of Architecture & Ekistics, Jamia Millia Islamia',
      //   'University School Of Architecture & Planning, Guru Gobind Singh Indraprastha University ',
      //   'MBS School Of Planning and Architecture',
      //   'Department Of Architecture, Indira Gandhi Delhi Technical University for Women',
      //   'Department Of Architecture, National Institute Of Technology Hamirpur',
      //   'APG School Of Architecture, A P Goyal Shimla University ',
      //   'Rajiv Gandhi Government Engineering College, Kangra',
      //   'Sushant School Of Art & Architecture, Ansal University',
      //   'Department Of Architecture, Deenbandhu Chhotu Ram University Of Science & Technology',
      //   'Gateway College Of Architecture & Design',
      //   'Budha College Of Architecture',
      //   'ICL Institute Of Architecture and Town Planning',
      //   'Lingaya’s University’s School Of Architecture',
      //   'Om Institute Of Architecture & Design',
      //   'Ganga Institute Of Architecture & Town Planning',
      //   'MM School Of Architecture, Maharishi Markandeshwar University',
      //   'Amity School Of Architecture & Planning, Amity University, Gurgaon',
      //   'Hindu College Of Design, Architecture & Planning',
      //   'State Institute Of Urban Planning & Architecture',
      //   'South Point School Of Architecture',
      //   'CCLS College Of Architecture & Design ',
      //   'P. M. College Of Architecture',
      //   'Delhi Global Institute Of Architecture',
      //   'School Of Architecture & Planning, K.R.Mangalam University ',
      //   'Bhagwan Mahaveer School Of Architecture',
      //   'Faculty Of Architecture & Town Planning, P. D. M University',
      //   'School Of Architecture & Planning, G. D. Goenka University ',
      //   'Delhi Institute Of Architecture & Planning',
      //   'Faculty Of Planning and Architecture, Manav Rachna International University',
      //   'Faculty Of Architecture & Planning, Jagan Nath University',
      //   'World School Of Planning and Architecture',
      //   'Jindal School Of Art and Architecture, O. P. Jindal Global University',
      //   'School Of Architecture & Landscape Design, Faculty Of Engineering, Shri Mata Vaishno Devi University',
      //   'Govt. M.A.M College, Jammu',
      //   'Abdul Ahad Azad Memorial Degree College, Bemina',
      //   'Department of Architecture, Guru Nanak Dev University',
      //   'School of Architecture, GianiZail Singh Campus College of Engineering &Technology',
      //   'Indo Global College of Architecture',
      //   'Chitkara School of Planning & Architecture',
      //   'College of Architecture, I.E.T.Bhaddal',
      //   'Lovely School of Architecture & Design, Lovely Professional University',
      //   'RIMT College of Architecture',
      //   'Sai School of Architecture',
      //   'University Institute of Architecture',
      //   'Department of Architecture, I.K.Gujral Punjab Technical University, Khunnimajra ',
      //   'CT Institute of Architecture and Planning',
      //   'School of Architecture, Shaheed Bhagat Singh State Technical Campus',
      //   'School of Architecture, CT University',
      //   'GNDEC School of Architecture',
      //   'Department of Architecture and Planning, Malviya National Institute of Technology ',
      //   'Department of Architecture & Town Planning, M.B.M.Engineering College, Faculty of Engineering & Architecture, Jai Narain Vyas University ',
      //   'Aayojan School of Architecture',
      //   'Faculty of Architecture, Jagannath University Jaipur',
      //   'Amity School of Architecture & Planning, Amity University Rajasthan ',
      //   'Buddha Institute of Architecture & Town Planning',
      //   'NIMS School of Architecture & Planning, NIMS University',
      //   'School of Architecture, Apex Group of Institution ',
      //   'St. Wilfred’s Institute of Architecture, Ajmer',
      //   'School of Architecture and Design, Manipal University, Jaipur',
      //   'School of Architecture, Dr. K. N. Modi University ',
      //   'School of Planning & Architecture, Poornima University',
      //   'School of Architecture, Central University of Rajasthan ',
      //   'College of Architecture & Design, Mody University of Science and Technology',
      //   'Faculty of Architecture & Planning, Vivekananda Global University ',
      //   'Department of Architecture & Planning, Indian Institute of Technology Roorkee',
      //   'DIT-Faculty of Architecture, Dehradun Institute of Technology',
      //   'Faculty of Architecture, Himgiri Zee University ',
      //   'School of Architecture and Planning, Graphic Era Hill University ',
      //   'Dev Bhoomi School of Architecture',
      //   'Faculty of Architecture, Dr.A.P.J.Abdul Kalam Technical University ',
      //   'Department of Architecture, Zakir Hussain College of Engineering & Technology',
      //   'Apeejay Institute of Technology\'s School of Architecture & Planning ',
      //   'School of Architecture & Planning, BabuBanarasi Das University ',
      //   'Faculty of Architecture, Integral University',
      //   'Amity School of Architecture & Planning, Amity University, Noida Campus Uttar Pradesh',
      //   'Amity School of Architecture and Planning, Amity University, Lucknow Campus, Uttar Pradesh ',
      //   'Sunder Deep College of Architecture',
      //   'Institute of Architecture and Town Planning, Bundelkhand University',
      //   'College of Architecture, Moradabad Educational Trust ',
      //   'Khandelwal College of Architecture and Design',
      //   'Teerthanker Mahaveer College of Architecture',
      //   'ITM School of Architecture & Town Planning',
      //   'School of Architecture, G.L.Bajaj Group of Institutions',
      //   'School of Architecture & Planning, Sharda University',
      //   'College of Architecture, Invertis University',
      //   'School of Architecture, Delhi Technical Campus',
      //   'Shri Ram School of Architecture',
      //   'School of Architecture & Town Planning, R.R.Institute of Modern Technology ',
      //   'Anand College of Architecture',
      //   'Centre for Architecture, Brahmanand Group of Institutions ',
      //   'Accurate Institute of Architecture & Planning',
      //   'Purvanchal Institute of Architecture & Design',
      //   'Ansal School of Architecture',
      //   'Forth Dimension College of Architecture',
      //   'Faculty of Architecture and Town Planning, Raja Balwant Singh Engineering Technical Campus Bichpuri',
      //   'Sanskar College of Architecture & Planning',
      //   'School of Architecture and Regional Planning, Gautam Buddha University',
      //   'Axis Institute of Architecture (AIA)',
      //   'Monad School of Architecture & Planning, Monad University',
      //   'School of Architecture, Galgotias University',
      //   'School of Architecture, Noida International University ',
      //   'Dayalbagh Educational Institute',
      //   'Institute of Architecture & Planning Shri Ramswaroop Memorial University',
      //   'College of Architecture, IIMT University',
      //   'Naraina School of Planning & Architecture',
      //   'College Of Engineering, Andhra University',
      //   'ANU College Of Architecture & Planning, Acharya Nagarjuna University ',
      //   'School Of Architecture, Gandhi Institute Of Technology and Management, (GITAM)',
      //   'Varaha College Of Architecture & Planning',
      //   'School Of Planning and Architecture, Vijayawada ',
      //   'M. R. K. College Of Architecture ',
      //   'Maestro School Of Planning and Architecture',
      //   'Department Of Architecture, K.L.E.F.University',
      //   'Vaishnavi School Of Architecture and Planning',
      //   'School Of Architecture, University Visvesvaraya College Of Engineering, Bangalore University',
      //   'Manipal School Of Architecture & Planning, Manipal University ',
      //   'School Of Design and Architecture, Manipal University - Dubai Campus (Study Centre)',
      //   'BMS College Of Architecture',
      //   'School Of Architecture, KLE Technological University',
      //   'Poojya Dr. Shivakumar Swamiji School Of Architecture ',
      //   'Dayananda Sagar School Of Architecture',
      //   'Department Of Architecture, BLDE Association\'s V.P. Dr. P. G. Halakatti College Of Engineering & Technology',
      //   'Malik Sandal Institute Of Art & Architecture ',
      //   'School Of Architecture, MS Ramaiah Institute Of Technology',
      //   'R. V. College Of Architecture (RVCA) ',
      //   'School Of Architecture, Siddaganga Institute Of Technology',
      //   'School Of Architecture, Karnataka Law Society\'s Gogte Institute Of Technology',
      //   'School Of Planning and Architecture, University Of Mysore',
      //   'Acharya’s NRV School Of Architecture',
      //   'BMS School Of Architecture',
      //   'The Oxford School Of Architecture, The Oxford College Of Engineering ',
      //   'School Of Architecture, Srinivas Institute Of Technology',
      //   'School Of Architecture, Dayananda Sagar Academy Of Technology and Management',
      //   'SJB School Of Architecture & Planning',
      //   'IMPACT School Of Architecture',
      //   'Gopalan School Of Architecture and Planning',
      //   'R. R. School Of Architecture ',
      //   'Mysore School Of Architecture',
      //   'BGS School Of Architecture and Planning',
      //   'Bearys Enviro-Architecture Design School',
      //   'Nitte Institute Of Architecture',
      //   'K. S. School Of Architecture ',
      //   'Wadiyar Centre for Architecture ',
      //   'Aditya Academy Of Architecture & Design',
      //   'School Of Architecture, Reva University',
      //   'School Of Architecture, CMR University',
      //   'School Of Architecture, HMS Institute Of Technology',
      //   'Faculty Of Architecture, PES University ',
      //   'Brindavan College Of Architecture',
      //   'Nitte School Of Architecture',
      //   'Angadi School Of Architecture ',
      //   'RNS School Of Architecture',
      //   'Sir M V School Of Architecture',
      //   'School Of Architecture, Christ University ',
      //   'East West School Of Architecture',
      //   'Department Of Architecture, Faculty Of Engineering & Technology',
      //   'Department Of Architecture, College Of Engineering Trivandrum',
      //   'School Of Architecture, TKM College Of Engineering',
      //   'School Of Architecture, MES College Of Engineering ',
      //   'Department Of Architecture, National Institute Of Technology Calicut ',
      //   'School Of Architecture, Government Engineering College Thrissur',
      //   'Devaki Amma’s Guruvayurappan College Of Architecture ',
      //   'Bishop Jerome School Of Architecture & Design',
      //   'School Of Architecture, Rajiv Gandhi Institute Of Technology ',
      //   'Holy Crescent College Of Architecture',
      //   'TKM School Of Architecture',
      //   'College Of Architecture Trivandrum',
      //   'IES College Of Architecture',
      //   'Al Salama Institute Of Architecture',
      //   'Sneha College Of Architecture',
      //   'School Of Architecture, College Of Engineering and Technology Payyanur',
      //   'Asian School Of Architecture and Design Innovation (ASADI)',
      //   'Global Institute Of Architecture',
      //   'KMCT College Of Architecture, Manassery',
      //   'KMCT College Of Architecture, Kallanthode',
      //   'KMEA College Of Architecture',
      //   'School Of Architecture, Mookambika Technical Campus ',
      //   'MES College Of Architecture',
      //   'Marian College Of Architecture & Planning',
      //   'Mangalam School Of Architecture and Planning ',
      //   'Nizar Rahim and Mark School Of Architecture',
      //   'Eranad Knowledge City College Of Architecture',
      //   'SCMS School Of Architecture',
      //   'Vedavyasa College Of Architecture',
      //   'Thejus College Of Architecture',
      //   'D. C. School Of Architecture and Design ',
      //   'Avani Institute Of Design',
      //   'Talent Institute Of Architecture (TIBA)',
      //   'Nehru College Of Architecture',
      //   'A. P. J. Abdul Kalam School Of Architecture, Mekkadambu',
      //   'MEA College Of Architecture, MEA Engineering College',
      //   'School of Architecture,Sri ManakulaVinayagar Engineering College ',
      //   'School of Architecture & Planning, Anna University',
      //   'Department of Architecture, National Institute of Technology Trichy',
      //   'School of Architecture, Adhiyamaan College of Engineering ',
      //   'School of Architecture & Interior Design, SRM Institute of Science and Technology ',
      //   'School of Architecture, Arulmigu Meenakshi Amman College of Engineering, Vadamavanda',
      //   'School of Architecture, Bharat University ',
      //   'School of Architecture, Hindustan Institute of Technology and Science ',
      //   'School of Architecture, Mohammed Sathak Engineering College Campus',
      //   'Department of Architecture, School of Building & Environment, Sathyabama University',
      //   'Department of Architecture, Thiagarajar College of Engineering, Thiruparankundram',
      //   'School of Architecture and Planning, Periyar Maniammai University',
      //   'MEASI Academy of Architecture',
      //   'Salem School of Architecture',
      //   'Tamil Nadu School of Architecture',
      //   'McGan’s Ooty School of Architecture',
      //   'School of Architecture, Meenakshi College of Engineering ',
      //   'Faculty of Architecture, Karpagam University ',
      //   'R.V.S. School of Architecture, Dindigul',
      //   'R.V.S. School of Architecture, Kumaran Kottam Campus',
      //   'EXCEL College of Architecture and Planning',
      //   'Ranganathan Architecture College',
      //   'Designed Environment Academy & Research Institute - DEAR Institute ',
      //   'School of Environment Architecture and Design (SEAD), SRM University, Ramapuram Campus ',
      //   'SVS School of Architecture',
      //   'Crescent School of Architecture',
      //   'Mohamed Sathak A.J. Academy of Architecture, Kancheepuram',
      //   'J.K.K.Munirajah School of Architecture',
      //   'M.A.M. School of Architecture',
      //   'C.A.R.E. School of Architecture',
      //   'Surya School of Architecture',
      //   'MARG Institute of Design and Architecture Swarnabhoomi (MIDAS) ',
      //   'Rajalakshmi School of Architecture',
      //   'RVS KVK School of Architecture, Trichy',
      //   'Aalim Muhammed Salegh Academy of Architecture Nizara Educational Campus ',
      //   'RVS Padmavathy School of Architecture',
      //   'Prime College of Architecture & Planning',
      //   'Faculty of Architecture, Dr. M.G.R. Educational and Research Institute University',
      //   'N. R. School of Architecture',
      //   'Skandha School of Architecture',
      //   'DA Vinci School of Design and Architecture',
      //   'Sasi Creative School of Architecture',
      //   'St.Peter’s School of Architecture, Tonakela',
      //   'St.Peter’s College of Engineering and Technology, Avadi ',
      //   'School of Architecture, Coimbatore Institute of Engineering and Technology',
      //   'Sigma College of Architecture',
      //   'Kalasalingam School of Architecture',
      //   'Anand School of Architecture',
      //   'Misrimal Navajee Munoth Jain School of Architecture',
      //   'Park Institute of Architecture',
      //   'Dhanalakshmi Srinivasan School of Architecture, Perambalur',
      //   'Dhanalakshmi Srinivasan School of Architecture, Trichy',
      //   'JK College of Architecture',
      //   'Capital College of Architecture',
      //   'CAAD-Chennai Academy of Architecture and Design',
      //   'MMES Academy of Architecture',
      //   'Kongu School of Architecture',
      //   'School of Architecture and Planning, Aarupadai Veedu Institute of Technology',
      //   'V.P.M.M. College of Architecture for Women',
      //   'School of Architecture, VIT University',
      //   'San Academy of Architecture',
      //   'Prime Nest College of Architecture and Planning',
      //   'Hindusthan School of Architecture',
      //   'Jaya School of Architecture',
      //   'Agni School of Architecture and Design Excellence (ASADE)',
      //   'Jawahar School of Architecture, Planning and Design',
      //   'Nehru School of Architecture',
      //   'School of Architecture, PRIST University',
      //   'Vivekanandhaa College of Architecture for Women',
      //   'Sree Sastha School of Architecture and Planning',
      //   'Rathinam School of Architecture',
      //   'Immanuel Arasar College of Architecture',
      //   'Tips School of Architecture',
      //   'Papni School of Architecture',
      //   'Chettinad School of Architecture',
      //   'Saveetha College of Architecture and Design',
      //   'Madha School of Architecture',
      //   'School of Planning & Architecture Jawaharlal Nehru Architecture and Fine Arts University (JNA&FAU)',
      //   'School of Architecture, CSI Institute of Technology ',
      //   'Sri Venkateswara College of Architecture',
      //   'Vaishnavi School of Architecture & Planning',
      //   'Maestro School of Planning and Architecture, Hyderabad',
      //   'Deccan School of Planning & Architecture',
      //   'School of Planning & Architecture (SPA), Jawaharlal Nehru Institute of Advanced Studies (JNIAS)',
      //   'J.B.R. Architecture College',
      //   'Aurora’s Design Academy',
      //   'Aurora’s Design Institute',
      //   'Ashoka School of Planning and Architecture',
      //   'GITAM School of Architecture, Hyderabad',
      //   'ICFAI School of Architecture',
      //   'Woxsen School of Architecture',
      //   'Goa College Of Architecture',
      //   'Department Of Architecture, M. S. University Of Baroda',
      //   'Faculty Of Architecture Centre for Environmental Planning & Technology University (CEPT University) ',
      //   'D.C. Patel School Of Architecture, Arvindbhai Patel Institute Of Environmental Design ',
      //   'Faculty Of Architecture, Sarvajanik College Of Engineering & Technology',
      //   'College Of Architecture, Sardar Vallabhai Patel Institute Of Technology ',
      //   'Vyavasay Vidya Pratishthan\'s Indubhai Parekh School Of Architecture',
      //   'School Of Architecture, Vadodara Design Academy ',
      //   'Institute Of Architecture, Hemchandracharya North Gujarat University ',
      //   'Shri Gijubhai Chhaganbhai Patel Institute Of Architecture, Interior Design and Fine Arts, Veer Narmad South Gujarat University',
      //   'Grow More School Of Architecture',
      //   'School Of Architecture, Anant National University ',
      //   'School Of Design and Architecture, Navrachana University',
      //   'Faculty Of Architecture, Parul Institute Of Architecture and Research, Parul University',
      //   'ITM School Of Architecture Art and Design',
      //   'Shantaben Manubhai Patel School Of Studies and Research in Architecture and Interior Design ',
      //   'Institute Of Design, Environment & Architecture, Indus University',
      //   'Bhagwan Mahavir College Of Architecture',
      //   'L. J. School Of Architecture',
      //   'Raman Bhakta School Of Architecture',
      //   'Institute Of Architecture & Planning, Nirma University',
      //   'Laxmi Institute Of Architecture',
      //   'Kalol Institute Of Architecture & Design',
      //   'Venus Institute Of Design & Architecture',
      //   'Sal School Of Architecture',
      //   'Institute Of Architecture, Ganpat University',
      //   'Vidyamandir College Of Architecture For Women',
      //   'Marwadi Education Foundation’s Group Of Institutions, Faculty Of Architecture',
      //   'Gokul College Of Architecture & Design',
      //   'Noble Architecture College',
      //   'Mudra Takshashila Institute Of Design & Architecture',
      //   'Alpha Institute Of Architecture Studies',
      //   'Mahavir Swami College Of Architecture',
      //   'P P Savani School Of Architecture',
      //   'Vadodara Institute Of Architecture',
      //   'Sir J. J. College Of Architecture',
      //   'L. S. Raheja School Of Architecture',
      //   'Academy Of Architecture',
      //   'Department Of Architecture and Planning, Visvesvaraya National Institute Of Technology',
      //   'BKPS College Of Architecture',
      //   'School Of Architecture, College Of Engineering & Technology, Near Shri Shivaji Park ',
      //   'D. Y. Patil College Of Engineering & Technology ',
      //   'School Of Architecture, G.S.Mandal\'s Marathwada Institute Of Technology',
      //   'Shri Prince Shivaji Maratha Boarding House\'s College Of Architecture',
      //   'Marathwada Mitra Mandal\'s College Of Architecture ',
      //   'School Of Architecture, Manoharbhai Patel Institute Of Engineering & Technology',
      //   'School Of Architecture, Jawahar Lal Nehru Engineering College',
      //   'MVP Samaj’s College Of Architecture',
      //   'Bharati Vidyapeeth’s College Of Architecture',
      //   'Kamla Raheja Vidyanidhi Institute for Architecture & Environmental Studies',
      //   'D. Y. Patil SchoolOf Architecture ',
      //   'Mahatma Education Society’s Pillais’ College Of Architecture ',
      //   'Rizvi College Of Architecture',
      //   'Bharati Vidyapeeth University’s College Of Architecture',
      //   'Smt. Manoramabai Mundle, College Of Architecture',
      //   'Maharshi KarveStree Shikshan Samstha\'s, Dr.Bhanuben Nanavati College Of Architecture for Women (BNCA)',
      //   'Shri SiddeshwarShikshan Mandal\'s College Of Architecture',
      //   'Shri V.B.Patil Trust’s Appasaheb Birnale College Of Architecture',
      //   'School Of Architecture, Kavikulguru Institute Of Technology & Science',
      //   'Priyadarshini Institute Of Architecture & Design Studies',
      //   'Indian Education Society’s College Of Architecture',
      //   'Dr. Baliram Hiray College Of Architecture ',
      //   'Pravara Rural College Of Architecture',
      //   'Vivekanand Institute Of Technology’s Padmabhushan Dr. Vasantdada Patil College Of Architecture',
      //   'Allana College Of Architecture',
      //   'Padmashree Dr. D.Y.Patil College Of Architecture ',
      //   'Sinhgad College Of Architecture',
      //   'Late Shri Bapuraoji Deshmukh Degree College Of Architecture',
      //   'Asmita College Of Architecture',
      //   'Balwant Sheth School Of Architecture, SVKM’s NMIMS ',
      //   'Shrikrishna Educational & Cultural Mandal’s, College Of Architecture ',
      //   'Samyak Sankalpa College Of Architecture ',
      //   'IDEAS - Institute Of Design Education & Architecture Studies',
      //   'Vidya Vardhan’s Institute Of Design Environment and Architecture ',
      //   'Vidya Pratishthan’s School Of Architecture',
      //   'ADA’s Minerva College Of Architecture',
      //   'P.R.Patil College Of Architecture',
      //   'Radhikatai Pandav Institute Of Architecture',
      //   'VIVA School Of Architecture',
      //   'Mahatma Education Society’s Pillai’s HOC College Of Architecture, Rasyani',
      //   'School Of Architecture, Anjuman-I-Islam’s Kalsekar Technical Campus ',
      //   'Dr. D Y Patil School Of Architecture ',
      //   'Lokmanya Tilak Institute Of Architecture & Design',
      //   'Tulsiramji Gaikwad-Patil College Of Architecture',
      //   'Oyster College Of Architecture',
      //   'St. Wilfred’s Institute Of Architecture ',
      //   'Aayojan School Of Architecture and Design',
      //   'Satish Misal Educational Foundation’s BRICK School Of Architecture',
      //   'Aditya College Of Architecture, C/o Aditya Educational Campus ',
      //   'Pravara Rural Education Society’s, College Of Architecture ',
      //   'Smt. Premalati Chavan College Of Architecture ',
      //   'Akhil Bharatiya Maratha Shikshan Parishad’s Anantrao Pawar College Of Architecture ',
      //   'IDEAL Institute Of Architecture',
      //   'Thakur School Of Architecture & Planning',
      //   'S. B. Patil College Of Architecture & Design',
      //   'D. Y. Patil School Of Architecture ',
      //   'School Of Environment and Architecture',
      //   'C. T. E. S. College Of Architecture',
      //   'Shree Chanakya Education Society’s Indira College Of Architecture and Design',
      //   'Trinity College Of Architecture',
      //   'Jai Shri Siddhivinayak Foundation Trust’s B. R. Harne College Of Architecture',
      //   'Jhulelal Institute Of Architecture',
      //   'Ideal College Of Architecture',
      //   'Shri Datta Meghe College Of Architecture',
      //   'Yashoda College Of Architecture Satara',
      //   'Amity School Of Architecture and Planning, Amity University Mumbai',
      //   'Smt. Kashibai Navale College Of Architecture ',
      //   'MET’s School Of Architecture and Interior Design',
      //   'Vishwaniketan’s College Of Architecture, Arts and Design',
      //   'Bharatratna Dr. A. P. J. Abdul Kalam College Of Architecture',
      //   'Shri Shivaji Maratha Society’s College Of Architecture',
      //   'Vidya Pratisthan’sIndapur College Of Architecture',
      //   'Walwa Taluka Education Society’s Shri S.D.Patil College Of Architecture',
      //   'Smt. K. L. Tiwari College Of Architecture',
      //   'MIT Art, Design & Technology University Pune’s School Of Architecture',
      //   'Pune District Education Association’s College Of Architecture',
      //   'Flora College Of Architecture',
      //   'Aditya College Of Architecture, Sarda Estate',
      //   'Ramesh Phirodia College Of Architecture',
      //   'Marathwada Mitra Mandals Institute Of Environmental & Designs College Of Architecture ',
      //   'School Of Architecture, Symbiosis Skills and Open University, Pune',
      //   'Vivekanand Education Society College Of Architecture ',
      //   'D. Y. Patil College Of Architecture, Kolhapur',
      //   'Vasantdada Patil Pratishthans’s Manoharphalke College Of Architecture ',
      //   'School Of Architecture, D Y Patil Deemed to be University',
      //   'School Of Architecture, Sanjay Ghodawat University, Kolhapur',
      //   'Solapur Education Society’s College Of Architecture ',
      //   'Dayanand College Of Architecture, Dayanand Education Society',
      //   'Dr Manoj A Shete College Of Architecture Kasara Tal Shahpu',
      //   'Siddant College Of Architecture',
      //   'Symbiosis School Of Planning,Architecture and Design ',
      //   'Ashokrao Mane College Of Architecture',
      //   'Tatyaasaheb Kore College Of Architecture, Warananagar',
      //   'Sipna School Of Planning and Architecture',
      //   'Indala School Of Architecture ',
      //   'Dr. J. J. Magdum College of Architecture ',
      //   'Vishwakarma University School of Architecture and Planning, Vishwakarma University',
      //   'School of Architecture, Chhatrapati Shivaji Maharaj University ',
      //   'Maulana Azad National Institute of Technology, Bhopal',
      //   'Department of Architecture. Madhav Institute of Technology & Science',
      //   'I.P.S.Academy\'s School of Architecture',
      //   'College of Architecture, SDPS Women’s College ',
      //   'Hitkarni College of Architecture & Town Planning',
      //   'Bagulamukhi College of Architecture & Planning',
      //   'Amity School of Architecture & Planning, Amity University, Madhya Pradesh',
      //   'School of Architecture & Design, ITM University Gwalior',
      //   'School of Planning & Architecture, Bhopal',
      //   'Faculty of Architecture, RKDF University',
      //   'Shri Vaishnav Institute of Architecture',
      //   'School of Architecture, LNCT University ',
      //   'Institute of Architecture, Sage University',
      //   'College of Architecture, Dr. A. P. J. Abdul Kalam University Indore',
      //   'School of Architecture, Rajiv Gandhi Proudyogiki Vishwavidyalaya',
      // ],
      intUniversities: [
        '7 (Seven) Star Interior Academy',
        'CAD CAM Trytoon Academy',
        'GIFT Design Academy ',
        'Glamour School of Fashion & Interiors',
        'INIFD, Kolkata',
        'Interior design institute Kolkata',
        'International Academy for Certification and Training (IACT) ',
        'International Institute of Fashion Design Academy of Interiors, Chandigarh',
        'JD Birla Institute',
        'JD Institute of Fashion Technology',
        'JD Institute of Fashion Technology, Cuttack ',
        'Maharaja Agrasen International College, Raipur',
        'National Institute of Design, West Bengal',
        'National Institute of Fashion Technology, Bhubaneshwar',
        'Pearl Academy, Kolkata',
        'Profex Institute, Bhubaneshwar',
        'Srimati Techno Institute-Kolkata',
        'The George Telegraph Training Institute -Agartala',
        'Trytoon Academy ',
        'Amity University, Jaipur',
        'Ansal University, New Delhi',
        'AP Goyal Shimla University',
        'Apex University',
        'Apex University, Jaipur',
        'Arch College of Design Business',
        'C T University',
        'Chitkara University',
        'Design Academy -Delhi ',
        'Design Development Academy Ahmedabad',
        'Design-O-Pedia-Delhi',
        'Dream Zone School of Creative Studies-Delhi',
        'IMS Design and Innovation Academy, Noida',
        'Indian Institute of Art and Design',
        'INIFD, Jaipur',
        'INIFD, Kanpur',
        'INIFD, Ludhiana',
        'International Institute of Fashion Design Academy of Interiors',
        'IVS School of Design-Delhi ',
        'J D Image Promotions Ltd',
        'J D Image Promotions Ltd, Delhi-Dwarka',
        'J D Image Promotions Ltd, Delhi-East Delhi',
        'J D Image Promotions Ltd, Delhi-Hauz Khas',
        'J D Image Promotions Ltd, Delhi-Kamala Nagar',
        'J D Image Promotions Ltd, Delhi-Pitampura',
        'J D Image Promotions Ltd, Delhi-Rajouri Garden',
        'J D Image Promotions Ltd, Gurugram',
        'J D Image Promotions Ltd, Kanpur',
        'J D Image Promotions Ltd, Lucknow',
        'J D Image Promotions Ltd, New Delhi',
        'J D Image Promotions Ltd, Noida',
        'Jindal Institute of Design, Delhi',
        'Lovely Professional University, Jalandhar',
        'Mahatma Jyoti Rao Phoole University, Jaipur',
        'Manav Rachna International University',
        'Mody University, Jaipur',
        'Pearl Academy, Delhi-South',
        'Pearl Academy, Jaipur',
        'Pearl Academy, Naraina Campus',
        'Pearl Academy, Rajouri Campus',
        'Poornima University',
        'Sai School of Interior Design',
        'School of Design and Visual Arts, Apeejay Stya University ',
        'Vasyaa International School of Design -Hyderabad',
        'VCD College of Designing',
        'VGU-Vivekananda Global University',
        'Aimfill International',
        'CREO Valley School of Creativity, Design and Management, Koramangala',
        'Gupta College of Management and Technology ',
        'Hamstech Academic Trust, Hyderabad',
        'ICAT Design and Media College, Bangalore ',
        'ICAT Design and Media College, Chennai',
        'IIFA Multimedia ',
        'INIFD, Bangalore',
        'INIFD, Chennai',
        'INIFD, Hyderabad-Himmayat Nagar',
        'INIFD, Hyderabad-Madhapur',
        'Inter National Institute of Fashion Design, HSR Layout ',
        'Interior Design Academy (IDA, Bangalore) ',
        'iPixio Design College ',
        'Jain University ',
        'JD Institute of Fashion Technology, Bangalore',
        'LISAA School of Design, Bangalore',
        'Mount Carmel College (MCC Bangalore) ',
        'Osteen College ',
        'Pearl Academy, Bengaluru',
        'Srishti Institute of Art, Design and Technology ',
        'Vogue Institute of Fashion Technology',
        'Academy of Architecture',
        'Aditya College of Design Studies-Mimbai',
        'Anantrao Pawar College of Architecture',
        'Art & Architecture Education & Research Trust (AAERT- Surat)',
        'Arvindbhai Patel Institute of Environmental Design (APIED)',
        'Dr. Bhanuben Nanavati College of Architecture',
        'Dream Zone School of Creative Studies-Ahmedabad',
        'IDT Interior Design Academy (IIDA), Surat',
        'India Institute of Technology (IIT) Bombay',
        'Indian Institute of Interior Design (IIID)',
        'INIFD, Ahmedabad',
        'INIFD, Baroda',
        'INIFD, Indore',
        'INIFD, Mumbai-Andheri',
        'INIFD, Mumbai-Borivali',
        'INIFD, Nagpur',
        'INIFD, Nasik',
        'INIFD, Navi Mumbai',
        'INIFD, Pune Kothrud',
        'INIFD, Rajkot',
        'INIFD, Surat',
        'INIFD, Thane',
        'J D Image Promotions Ltd, Mumbai',
        'J D Image Promotions Ltd, Surat',
        'J D Image Promotions Ltd, Vadodra',
        'JJ School of Arts',
        'Lady Amrithal Daga College, Nagpur',
        'Pearl Academy, Mumbai',
        'Sarvajanik Education Society\'s Sarvajanik School of Interior Design',
        'SDPS Womens College of Interior Designing',
        'Shree Chanakaya Education Society',
        'Shri Manilal Nanavati Vocational Training Institute',
        'Sinhgad Institute of Architecture & Design Studies',
        'SMEF\'S BricksSchool of Interior Design',
        'SNDT Women\'s University',
        'Suryadatta Institute of Vocational & Advanced Studies',
        'Pune Institute of Applied Technology (PIAT, Pune)'
      ],
      // cities: ["Mumbai","Delhi","Bangalore","Hyderabad","Ahmedabad","Chennai","Kolkata","Surat","Pune","Jaipur","Lucknow","Kanpur","Nagpur","Indore","Thane","Bhopal","Visakhapatnam","Pimpri-Chinchwad","Patna","Vadodara","Ghaziabad","Ludhiana","Agra","Nashik","Ranchi","Faridabad","Meerut","Rajkot","Kalyan-Dombivli","Vasai-Virar","Varanasi","Srinagar","Aurangabad","Dhanbad","Amritsar","Navi Mumbai","Allahabad","Howrah","Gwalior","Jabalpur","Coimbatore","Vijayawada","Jodhpur","Madurai","Raipur","Chandigarh","Guwahati","Solapur","Hubli–Dharwad","Mysore","Tiruchirappalli","Bareilly","Aligarh","Tiruppur","Gurgaon","Moradabad","Jalandhar","Bhubaneswar","Salem","Warangal","Mira-Bhayandar","Jalgaon","Kota","Guntur","Bhiwandi","Saharanpur","Gorakhpur","Bikaner","Amravati","Noida","Jamshedpur","Bhilai","Cuttack","Firozabad","Kochi","Nellore","Bhavnagar","Dehradun","Durgapur","Asansol","Rourkela","Nanded","Kolhapur","Ajmer","Akola","Gulbarga","Jamnagar","Ujjain","Loni","Siliguri","Jhansi","Ulhasnagar","Jammu","Sangli-Miraj &amp; Kupwad","Mangalore","Erode","Belgaum","Ambattur","Tirunelveli","Malegaon","Gaya","Thiruvananthapuram","Udaipur","Kakinada","Davanagere","Kozhikode","Maheshtala","Rajpur Sonarpur","Rajahmundry","Bokaro","South Dumdum","Bellary","Patiala","Gopalpur","Agartala","Bhagalpur","Muzaffarnagar","Bhatpara","Panihati","Latur","Dhule","Tirupati","Rohtak","Sagar","Korba","Bhilwara","Berhampur","Muzaffarpur","Ahmednagar","Mathura","Kollam","Avadi","Kadapa","Kamarhati","Sambalpur","Bilaspur","Shahjahanpur","Satara","Bijapur","Kurnool","Rampur","Shimoga","Chandrapur","Junagadh","Thrissur","Alwar","Bardhaman","Kulti","Nizamabad","Parbhani","Tumkur","Khammam","Ozhukarai","Bihar Sharif","Panipat","Darbhanga","Bally","Aizawl","Dewas","Ichalkaranji","Karnal","Bathinda","Jalna","Eluru","Barasat","Kirari Suleman Nagar","Purnia","Satna","Mau","Sonipat","Farrukhabad","Durg","Imphal","Ratlam","Hapur","Arrah","Anantapur","Karimnagar","Etawah","Ambarnath","North Dumdum","Bharatpur","Begusarai","New Delhi","Gandhidham","Baranagar","Tiruvottiyur","Pondicherry","Sikar","Thoothukudi","Rewa","Mirzapur","Raichur","Pali","Ramagundam","Silchar","Haridwar","Vijayanagaram","Tenali","Nagercoil","Sri Ganganagar","Karawal Nagar","Mango","Thanjavur","Bulandshahr","Uluberia","Katni","Sambhal","Singrauli","Nadiad","Secunderabad","Naihati","Yamunanagar","Bidhannagar","Pallavaram","Bidar","Munger","Panchkula","Burhanpur","Raurkela Industrial Township","Kharagpur","Dindigul","Gandhinagar","Hospet","Nangloi Jat","Malda","Ongole","Deoghar","Chapra","Haldia","Khandwa","Nandyal","Morena","Amroha","Anand","Bhind","Bhalswa Jahangir Pur","Madhyamgram","Bhiwani","Berhampore","Ambala","Morbi","Fatehpur","Raebareli","Khora, Ghaziabad","Chittoor","Bhusawal","Orai","Bahraich","Phusro","Vellore","Mehsana","Raiganj","Sirsa","Danapur","Serampore","Sultan Pur Majra","Guna","Jaunpur","Panvel","Shivpuri","Surendranagar Dudhrej","Unnao","Chinsurah","Alappuzha","Kottayam","Machilipatnam","Shimla","Adoni","Udupi","Katihar","Proddatur","Mahbubnagar","Saharsa","Dibrugarh","Jorhat","Hazaribagh","Hindupur","Nagaon","Sasaram","Hajipur","Giridih","Bhimavaram","Kumbakonam","Bongaigaon","Dehri","Madanapalle","Siwan","Bettiah","Ramgarh","Tinsukia","Guntakal","Srikakulam","Motihari","Dharmavaram","Medininagar","Gudivada","Phagwara","Hosur","Narasaraopet","Suryapet","Miryalaguda","Tadipatri","Karaikudi","Kishanganj","Jamalpur","Ballia","Kavali","Tadepalligudem","Amaravati","Buxar","Tezpur","Jehanabad","Aurangabad","Gangtok"],
      states: ["Andhra Pradesh","Assam","Bihar","Chhattisgarh","Delhi","Gujarat","Haryana","Himachal Pradesh","Jammu and Kashmir","Jharkhand","Karnataka","Kerala","Madhya Pradesh","Maharashtra","Odisha","Punjab and Chandigarh","Rajasthan","Tamil Nadu","Telangana","Uttar Pradesh","Uttarakhand","West Bengal"],
      universities: [
      "University of Delhi",
      "Indian Institute of Technology Bombay",
      "Indian Institute of Technology Kanpur",
      "Indian Institute of Technology Madras",
      "Indian Institute of Technology Delhi",
      "Indian Institute of Technology Kharagpur",
      "Narsee Monjee Institute of Management and Higher Studies",
      "Savitribai Phule Pune University",
      "VIT University",
      "Amity University",
      "Indian Institute of Technology Guwahati",
      "Tata Institute of Fundamental Research",
      "Jawaharlal Nehru University",
      "Birla Institute of Technology and Science",
      "Amrita Vishwa Vidyapeetham",
      "Indian Institute of Science",
      "Manipal Academy of Higher Education",
      "International Institute of Information Technology, Hyderabad",
      "SRM Institute of Science and Technology",
      "Lovely Professional University",
      "Tata Institute of Social Sciences",
      "Banaras Hindu University",
      "Anna University",
      "University of Mumbai",
      "All India Institute of Medical Sciences Delhi",
      "Tamil Nadu Agricultural University",
      "Gujarat Technological University",
      "Aligarh Muslim University",
      "Indian Institute of Technology Roorkee",
      "Chandigarh University",
      "Indian Statistical Institute",
      "Christ University",
      "Kurukshetra University",
      "Guru Gobind Singh Indraprastha University",
      "Indian Institute of Technology Gandhinagar",
      "Osmania University",
      "National Institute of Technology, Rourkela",
      "Jamia Millia Islamia",
      "Cochin University of Science and Technology",
      "National Institute of Design",
      "National Institute of Technology, Tiruchirappalli",
      "University of Hyderabad",
      "Dr. A.P.J. Abdul Kalam Technical University",
      "Indian Institute of Technology Hyderabad",
      "University of Petroleum and Energy Studies",
      "University of Lucknow",
      "University of Calcutta",
      "Sharda University",
      "University of Mysore",
      "National Institute of Fashion Technology",
      "University of Madras",
      "University of Calicut",
      "Visvesvaraya Technological University",
      "Panjab University",
      "Pondicherry University",
      "SASTRA University",
      "Gandhi Institute of Technology and Management",
      "Post Graduate Institute of Medical Education and Research",
      "National Institute of Technology, Calicut",
      "University of Kerala",
      "University of Rajasthan",
      "Thapar Institute of Engineering and Technology",
      "The Maharaja Sayajirao University of Baroda",
      "Mahatma Gandhi University",
      "National Law School of India University",
      "Jadavpur University",
      "Jawaharlal Institute of Postgraduate Medical Education and Research",
      "Birla Institute of Technology",
      "Nirma University",
      "North Eastern Hill University",
      "University of Allahabad",
      "Chitkara University, Punjab",
      "Ashoka University",
      "Maulana Abul Kalam Azad University of Technology, West Bengal",
      "Annamalai University",
      "Motilal Nehru National Institute of Technology Allahabad",
      "Delhi Technological University",
      "Indira Gandhi Institute of Development Research",
      "National Institute of Mental Health and Neuro Sciences",
      "Indian Institute of Information Technology Allahabad",
      "International Institute of Information Technology Bangalore",
      "Indraprastha Institute of Information Technology",
      "Jawaharlal Nehru Centre for Advanced Scientific Research",
      "Devi Ahilya Vishwavidyalaya",
      "KIIT University",
      "Azim Premji University",
      "Indian Institute of Science Education and Research, Pune",
      "Chennai Mathematical Institute",
      "Bharathidasan University",
      "Tezpur University",
      "Chhatrapati Shahu Ji Maharaj University",
      "Shiv Nadar University",
      "Indian Institute of Technology Mandi",
      "Indian Institute of Technology, BHU",
      "University of Burdwan",
      "Gauhati University",
      "APJ Abdul Kalam Technological University",
      "Indian Institute of Technology Jodhpur",
      "Indian Institute of Technology Bhubaneswar",
      "Guru Nanak Dev University",
      "Madurai Kamaraj University",
      "Rajiv Gandhi Proudyogiki Vishwavidyalaya",
      "Chaudhary Charan Singh University",
      "Gujarat University",
      "Kerala Agricultural University",
      "Galgotias University",
      "Jain University",
      "CEPT University",
      "Visva-Bharati University",
      "Indian Institute of Space Science and Technology",
      "Symbiosis International University",
      "Govind Ballabh Pant University of Agriculture and Technology",
      "Malaviya National Institute of Technology, Jaipur",
      "Sikkim University",
      "K L University",
      "University of Kashmir",
      "Andhra University",
      "Jawaharlal Nehru Technological University",
      "Rajasthan Technical University Kota",
      "Indian Institute of Technology Patna",
      "Indian School of Mines",
      "Punjab Technical University",
      "Himachal Pradesh University",
      "Dr. B R Ambedkar National Institute of Technology Jalandhar",
      "Jamia Hamdard",
      "Indian Institute of Technology Ropar",
      "Saurashtra University",
      "Dhirubhai Ambani Institute of Information and Communication Technology",
      "Indian Agricultural Research Institute",
      "Invertis University",
      "Sanjay Gandhi Post Graduate Institute of Medical Sciences",
      "Bangalore University",
      "Dibrugarh University",
      "National Institute of Technology, Silchar",
      "Veer Narmad South Gujarat University",
      "Goa University",
      "Indian Institute of Science Education and Research, Kolkata",
      "O.P. Jindal Global University",
      "Sardar Patel University",
      "Maulana Azad National Institute of Technology",
      "Bennett University",
      "Dayalbagh Educational Institute",
      "Sardar Vallabhbhai National Institute of Technology, Surat",
      "National Law University, Delhi",
      "Indian Institute of Technology Indore",
      "Presidency University",
      "Punjab Agricultural University",
      "Baba Farid University of Health Sciences",
      "National Institute of Technology, Kurukshetra",
      "Karunya Institute of Technology and Sciences",
      "Sathyabama Institute of Science and Technology",
      "National Institute of Technology, Warangal",
      "Sree Chitra Thirunal Institute of Medical Sciences and Technology",
      "Visvesvaraya National Institute of Technology",
      "Ambedkar University Delhi",
      "DIT University",
      "Bharathiar University",
      "Jiwaji University",
      "Padmashree Dr. D.Y. Patil Vidyapith",
      "ITM University Raipur",
      "North Maharashtra University",
      "Sri Ramachandra Institute of Higher Education and Research",
      "All India Institute of Medical Sciences Raipur",
      "All India Institute of Medical Sciences Rishikesh",
      "Jawaharlal Nehru Technological University, Kakinada",
      "Swami Vivekanand Subharti University",
      "Indian Veterinary Research Institute",
      "International Institute for Population Sciences",
      "All India Institute of Medical Sciences Jodhpur",
      "Alagappa University",
      "Graphic Era University",
      "PES University",
      "All India Institute of Medical Sciences Bhopal",
      "Pandit Deendayal Petroleum University",
      "Swami Ramanand Teerth Marathwada University",
      "National Institute of Technology, Jamshedpur",
      "Shivaji University",
      "National Institute of Educational Planning and Administration",
      "Ahmedabad University",
      "Periyar University",
      "BML Munjal University",
      "Mohanlal Sukhadia University",
      "Rajiv Gandhi Institute of Petroleum Technology",
      "All India Institute of Medical Sciences Patna",
      "Indian Institute of Science Education and Research, Thiruvananthapuram",
      "Kalasalingam University",
      "NALSAR University of Law",
      "Gujarat National Law University",
      "Dr. N.T.R. University of Health Sciences",
      "Indian Institute of Science Education and Research, Mohali",
      "Indira Gandhi Krishi Vishwavidyalaya",
      "Hindustan Institute of Technology and Science",
      "Punjabi University Patiala",
      "M.J.P. Rohilkhand University",
      "Indian Institute of Engineering Science and Technology, Shibpur",
      "Banasthali Vidyapith",
      "Dr. Vishwanath Karad MIT World Peace University",
      "The West Bengal National University of Juridical Sciences",
      "National Institute of Technology, Durgapur",
      "Sikkim Manipal University",
      "Rajiv Gandhi University of Health Sciences",
      "Hemwati Nandan Bahuguna Garhwal University",
      "Alliance University",
      "Vel Tech Rangarajan Dr. Sagunthala R&D Institute of Science and Technology",
      "Gandhigram Rural University",
      "Bharati Vidyapeeth Deemed University",
      "Rajasthan University of Health Sciences",
      "All India Institute of Medical Sciences Bhubaneswar",
      "Sant Gadge Baba Amravati University",
      "Guru Jambheshwar University of Science and Technology",
      "Assam University",
      "Acharya Nagarjuna University",
      "Kannur University",
      "Dr. Shakuntala Misra Rehabilitation University",
      "National Institute of Technology, Hamirpur",
      "King George's Medical University",
      "Babasaheb Bhimrao Ambedkar University",
      "Pt. Bhagwat Dayal Sharma University of Health Sciences",
      "University of Jammu",
      "South Asian University",
      "Parul University",
      "Central University of Rajasthan",
      "REVA University",
      "Rani Durgavati Vishwavidyalaya",
      "TERI School of Advanced Studies",
      "Flame University",
      "Jaypee University of Information Technology",
      "Baba Ghulam Shah Badhshah University",
      "Vinayaka Missions University",
      "The Northcap University",
      "Dr. Rajendra Prasad Central Agricultural University",
      "Indian Institute of Science Education and Research, Bhopal",
      "Shree Guru Gobind Singh Tricentenary University",
      "National Institute of Technology, Raipur",
      "Jai Prakash Vishwavidyalaya",
      "Bundelkhand University",
      "Chhattisgarh Swami Vivekananda Technical University",
      "Assam Agricultural University",
      "Maharishi Dayanand University",
      "Rashtriya Sanskrit Sansthan University",
      "Hemchandracharya North Gujarat University",
      "Guru Ghasidas Vishwavidyalaya",
      "Veer Surendra Sai University of Technology",
      "Dr. Bhimrao Ambedkar University",
      "Maharishi Markandeshwar University, Mullana",
      "Jaipur National University",
      "University of Solapur",
      "KLE University",
      "Maharashtra University of Health Sciences",
      "Ranchi University",
      "Indian Maritime University",
      "Veer Bahadur Singh Purvanchal University",
      "Bharath Institute of Higher Education and Research",
      "Sri Venkateswara Institute of Medical Sciences",
      "Shri Mata Vaishno Devi University",
      "Patna University",
      "Siksha O Anusandhan University",
      "Suresh Gyan Vihar University",
      "Mahatma Gandhi Kashi Vidyapeeth",
      "Jaypee Institute of Information Technology",
      "University of Kalyani",
      "Acharya N.G. Ranga Agricultural University",
      "The English and Foreign Languages University",
      "University of Agricultural Sciences, Bangalore",
      "School of Planning and Architecture, Delhi",
      "Ganpat University",
      "Institute of Chemical Technology",
      "CSK Himachal Pradesh Krishi Vishvavidyalaya",
      "Kumaun University",
      "Dr. Ram Manohar Lohia Avadh University",
      "Sher-i-Kashmir Institute of Medical Sciences",
      "NITTE University",
      "National Institute of Technology, Karnataka",
      "National Institute of Technology, Agartala",
      "Deen Dayal Upadhyay Gorakhpur University",
      "National Law University, Jodhpur",
      "Vels University",
      "Tripura University",
      "Tamil Nadu Teacher Education University",
      "Mangalore University",
      "Nalanda University",
      "Dr. Babasaheb Ambedkar Marathwada University",
      "National Institute of Technology, Patna",
      "Orissa University of Agriculture and Technology",
      "NIIT University",
      "Rabindra Bharati University",
      "Tamil Nadu Veterinary and Animal Sciences University",
      "Anand Agricultural University",
      "Deenbandhu Chhotu Ram University of Science and Technology",
      "Indian Institute of Information Technology and Management Gwalior",
      "Dr. D.Y. Patil Vidyapeeth",
      "National Institute of Pharmaceutical Education and Research, Mohali",
      "Makhanlal Chaturvedi Rashtriya Patrakarita Vishwavidyalaya",
      "The LNM Institute of Information Technology",
      "Central University of Tamil Nadu",
      "Ansal University",
      "Maharaja Krishnakumarsinhji Bhavnagar University",
      "Vignan University",
      "Mizoram University",
      "Chaudhary Charan Singh Haryana Agricultural University",
      "Jawaharlal Nehru Technological University, Anantapur",
      "Central University of Jharkhand",
      "Manonmaniam Sundaranar University",
      "West Bengal University of Health Sciences",
      "Madan Mohan Malaviya University of Technology",
      "Kuvempu University",
      "Indira Gandhi National Tribal University",
      "Uka Tarsadia University",
      "Xavier University Bhubaneswar",
      "Graphic Era Hill University",
      "Navsari Agricultural University",
      "Integral University",
      "Centurion University of Technology and Management",
      "JECRC University",
      "Karnatak University",
      "Bidhan Chandra Krishi Vishwavidyalaya",
      "Rajiv Gandhi University",
      "Tamil Nadu Dr. M.G.R.Medical University",
      "Assam Don Bosco University",
      "Marwadi University",
      "Kakatiya University",
      "Indian Institute of Information Technology, Design and Manufacturing",
      "Manipur University",
      "University of North Bengal",
      "Barkatullah University",
      "Saveetha University",
      "Atmiya University",
      "National Institute of Technology, Srinagar",
      "Gautam Buddha University",
      "Apeejay Stya University",
      "National Dairy Research Institute",
      "Dayananda Sagar University",
      "Utkal University",
      "University of Agricultural Sciences, Dharwad",
      "NIMS University",
      "Sher-e-Kashmir University of Agricultural Sciences and Technology of Kashmir",
      "Biju Patnaik University of Technology",
      "Himachal Pradesh Technical University",
      "Gokhale Institute of Politics and Economics",
      "National Institute of Technology, Delhi",
      "The IIS University",
      "Central University of Gujarat",
      "Maulana Mazharul Haque Arabic and Persian University",
      "GLA University",
      "Shoolini University of Biotechnology and Management Sciences",
      "IIHMR University",
      "Dr. Hari Singh Gour University",
      "Shreemati Nathibai Damodar Thackersey Women's University",
      "Poornima University",
      "Central University of South Bihar",
      "PDPM Indian Institute of Information Technology, Design and Manufacturing",
      "Sant Longowal Institute of Engineering and Technology",
      "Gujarat Ayurved University",
      "Pravara Institute of Medical Sciences",
      "Jawaharlal Nehru Krishi Vishwavidyalaya",
      "Rajasthan University of Veterinary and Animal Sciences",
      "Central University of Karnataka",
      "Gujarat Vidyapith",
      "Garden City University",
      "Krantiguru Shyamji Krishna Verma Kachchh University",
      "Pandit Ravishankar Shukla University",
      "National Institute of Food Technology Entrepreneurship and Management",
      "Central University of Haryana",
      "Magadh University",
      "SRM University Haryana",
      "Maharaja Ganga Singh University",
      "Veer Kunwar Singh University",
      "Rajiv Gandhi University of Knowledge Technologies",
      "Sam Higginbottom Institute of Agriculture, Technology and Sciences",
      "North Eastern Regional Institute of Science and Technology",
      "Guru Angad Dev Veterinary and Animal Sciences University",
      "Uttarakhand Technical University",
      "Central University of Himachal Pradesh",
      "Gujarat Forensic Sciences University",
      "AKS University",
      "Central University of Kashmir",
      "National Institute of Technology, Meghalaya",
      "JK Lakshmipat University",
      "B.S. Abdur Rahman Crescent Institute of Science and Technology",
      "Central University of Orissa",
      "Rashtrasant Tukadoji Maharaj Nagpur University",
      "J.C. Bose University of Science and Technology",
      "GD Goenka University",
      "Nagaland University",
      "M.S. Ramaiah University of Applied Sciences",
      "Nizam's Institute of Medical Sciences",
      "University of Engineering and Management, Kolkata",
      "Sri Venkateswara University",
      "JSS Academy of Higher Education and Research",
      "Assam Science and Technology University",
      "Uttaranchal University",
      "Hidayatullah National Law University",
      "National Law Institute University",
      "Dr. Babasaheb Ambedkar Technological University",
      "National Institute of Technology, Uttarakhand",
      "Lakshmibai National Institute of Physical Education",
      "Glocal University",
      "Central Institute of Fisheries Education",
      "Dr. Y.S. Parmar University of Horticulture and Forestry",
      "Islamic University of Science and Technology",
      "Homi Bhabha National Institute",
      "VIT Bhopal University",
      "Kavi Kulguru Kalidas Sanskrit Vishwavidyalaya",
      "Central University of Punjab",
      "The Indian Law Institute",
      "Dr. M.G.R. Educational and Research Institute",
      "Lalit Narayan Mithila University",
      "Vasantrao Naik Marathwada Krishi Vidyapeeth",
      "Swarnim Gujarat Sports University",
      "Maulana Azad National Urdu University",
      "Mahatma Phule Krishi Vidyapeeth",
      "National Institute of Technology, Goa",
      "Mody University of Science and Technology",
      "Junagadh Agricultural University",
      "Ramakrishna Mission Vivekananda University",
      "IFHE Hyderabad",
      "Sri Padmavati Mahila Visvavidyalayam",
      "University of Kota",
      "K.R. Mangalam University",
      "Chaudhary Ranbir Singh University",
      "Presidency University",
      "ICFAI University, Tripura",
      "Adikavi Nannaya University",
      "Arunachal University of Studies",
      "National Institute of Technology, Puducherry",
      "Janardan Rai Nagar Rajasthan Vidhyapeeth University",
      "Tilak Maharashtra Vidyapeeth",
      "National Institute of Technology, Arunachal Pradesh",
      "Sambalpur University",
      "Teerthanker Mahaveer University",
      "Jaypee University of Engineering and Technology",
      "Dev Sanskriti Vishwavidyalaya",
      "Vinoba Bhave University",
      "ITM University Gwalior",
      "Rajiv Gandhi National Institute of Youth Development",
      "Central University of Kerala",
      "Mahatma Gandhi Central University, Motihari",
      "Avinashilingam University",
      "Jai Narain Vyas University",
      "Charotar University of Science and Technology",
      "Babasaheb Bhimrao Ambedkar Bihar University",
      "Dr. Balasaheb Sawant Konkan Krishi Vidyapeeth",
      "Jayoti Vidyapeeth Women's University",
      "Indian Institute of Information Technology, Guwahati",
      "Tumkur University",
      "Mewar University",
      "ICFAI University, Dehradun",
      "Indira Gandhi University, Meerpur",
      "Sri Krishnadevaraya University",
      "International Institute of Information Technology, Bhubaneswar",
      "Krishna University",
      "Central University of Jammu",
      "Maharshi Panini Sanskrit Vishwavidyalaya",
      "DAV University",
      "School of Planning and Architecture, Bhopal",
      "Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha",
      "Shobhit University",
      "Jawaharlal Nehru Architecture and Fine Arts University",
      "Swami Vivekananda Yoga Anusandhana Samsthana",
      "Kerala University of Fisheries and Ocean Studies",
      "National Institute of Technology, Mizoram",
      "St. Peter's University",
      "The National University of Advanced Legal Studies",
      "Indira Gandhi Institute of Medical Sciences, Sheikhpura",
      "Pandit Deendayal Upadhyaya Shekhawati University",
      "Maharaja Ranjit Singh Punjab Technical University",
      "University of Gour Banga",
      "Aliah University",
      "Chanakya National Law University",
      "National Institute of Technology, Manipur",
      "National Institute of Pharmaceutical Education and Research, Ahmedabad",
      "Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya",
      "Rajiv Gandhi National University of Law",
      "Maharana Pratap University of Agriculture and Technology",
      "Rani Channamma University, Belagavi",
      "Dravidian University",
      "Mahatma Gandhi Antarrashtriya Hindi Vishwavidyalaya",
      "Gurukul Kangri Vishwavidyalaya",
      "Professor Jayashankar Telangana State Agricultural University",
      "Dr K.N. Modi University",
      "Tilka Manjhi Bhagalpur University",
      "Bihar Agricultural University",
      "Avantika University",
      "Kolhan University",
      "National Institute of Technology, Sikkim",
      "Lingaya's University",
      "Chandra Shekhar Azad University of Agriculture and Technology",
      "Maharshi Dayanand Saraswati University",
      "Harcourt Butler Technical University",
      "Indira Gandhi Delhi Technical University for Women",
      "Rashtriya Sanskrit Vidyapeetha",
      "Tamil Nadu Dr Ambedkar Law University",
      "Kerala Veterinary and Animal Sciences University",
      "Indian Institute of Teacher Education",
      "Babu Banarasi Das University",
      "Forest Research Institute",
      "Bhartiya Skill Development University",
      "Sri Sathya Sai Institute of Higher Learning",
      "Dr. C.V. Raman University",
      "Mother Teresa Women's University",
      "Tamil Nadu Physical Education and Sports University",
      "Career Point University",
      "Dr. Ram Manohar Lohiya National Law University",
      "Aryabhatta Knowledge University",
      "Rama University",
      "Noida International University",
      "Ravenshaw University",
      "IMS Unison University",
      "Quantum University",
      "Berhampur University",
      "Doon University",
      "OPJS University",
      "Madhav University",
      "Indian Institute of Information Technology, Vadodara",
      "West Bengal State University",
      "Yenepoya University",
      "Chaudhary Devi Lal University",
      "National Institute of Technology, Nagaland",
      "Vikrama Simhapuri University",
      "Yogi Vemana University",
      "Birsa Agricultural University",
      "Periyar Maniammai Institute of Science and Technology",
      "Sri Sri University",
      "Kerala University of Health Sciences",
      "Adamas University",
      "Dr. Panjabrao Deshmukh Krishi Vidyapeeth",
      "Cotton University",
      "Brainware University",
      "Indian Institute of Information Technology, Sri City",
      "Sage University",
      "Sanskriti University",
      "Medi-Caps University",
      "Dharmsinh Desai University",
      "Singhania University",
      "Jain Vishva Bharati Institute",
      "PEC University of Technology",
      "Assam Down Town University",
      "Central Agricultural University",
      "Karnataka State Law University",
      "Rayalaseema University",
      "Vikram University",
      "RK University",
      "Sir Padampat Singhania University",
      "Pacific University, India",
      "Fakir Mohan University",
      "National Law University, Orissa",
      "National Law University and Judicial Academy",
      "Sandip University",
      "Sree Sankaracharya University of Sanskrit",
      "Gondwana University",
      "Rabindranath Tagore University",
      "Rai University",
      "Sarguja University",
      "AP Goyal Shimla University",
      "University of Science and Technology, Meghalaya",
      "Kaziranga University",
      "Dr.Y.S.R. Horticultural University",
      "Satavahana University",
      "Tamil University",
      "Telangana University",
      "Sardarkrushinagar Dantiwada Agricultural University",
      "Atal Bihari Vajpayee Vishwavidyalaya",
      "Sri Balaji Vidyapeeth",
      "People's University",
      "Vidyasagar University",
      "Kannada University",
      "Lala Lajpat Rai University of Veterinary and Animal Sciences",
      "Jagannath University",
      "Anant National University",
      "RIMT University",
      "Thiruvalluvar University",
      "Maharashtra Animal and Fishery Sciences University",
      "IEC University",
      "Maharishi Mahesh Yogi Vedic Vishwavidyalaya",
      "Rajmata Vijayaraje Scindia Krishi Vishwavidyalaya",
      "MIT Art Design and Technology University",
      "MGM Institute of Health Sciences",
      "Potti Sreeramulu Telugu University",
      "Deccan College Post-Graduate and Research Institute",
      "National Institute of Pharmaceutical Education and Research, Hyderabad",
      "MATS University",
      "School of Planning and Architecture, Vijayawada",
      "Uttar Pradesh University of Medical Sciences",
      "CMR University",
      "Vivekananda Global University",
      "Awadhesh Pratap Singh University",
      "Vishwakarma University",
      "Bodoland University",
      "Chaudhary Bansi Lal University",
      "National University of Study and Research in Law",
      "Mangalayatan University",
      "West Bengal University of Animal and Fishery Sciences",
      "Swami Rama Himalayan University",
      "Ponnaiyan Ramajayam Institute of Science and Technology",
      "Himalayan University",
      "Delhi Pharmaceutical Sciences and Research University",
      "Tamil Nadu Dr. J. Jayalalithaa Fisheries University",
      "BLDE University",
      "Institute of Infrastructure, Technology, Research and Management",
      "Santosh University",
      "Palamuru University",
      "Datta Meghe Institute of Medical Sciences",
      "Sri Venkateswara Veterinary University",
      "International Institute of Information Technology, Naya Raipur",
      "AURO University",
      "Swami Keshwanand Rajasthan Agricultural University",
      "Mahatma Gandhi University, Meghalaya",
      "GNA University",
      "Rayat-Bahra University",
      "Maharaja Surajmal Brij University",
      "U.P. Pandit Deen Dayal Upadhyaya Pashu Chikitsa Vigyan Vishwavidyalaya Evam Go-Anusandhan Sansthan",
      "Sri Guru Granth Sahib World University",
      "Sher-e-Kashmir University of Agricultural Sciences and Technology of Jammu",
      "Kalinga University",
      "PDM University",
      "Krishna Institute of Medical Sciences",
      "Chitkara University, Himachal Pradesh",
      "Sardar Vallabhbhai Patel University of Agriculture and Technology",
      "Kadi Sarva Vishwavidyalaya",
      "Siddharth University",
      "Damodaram Sanjivayya National Law University",
      "Desh Bhagat University",
      "Techno India University",
      "North Orissa University",
      "Kazi Nazrul University",
      "Ajeenkya D.Y. Patil University",
      "Shri Ramswaroop Memorial University",
      "Indian Institute of Information Technology, Una",
      "Jagran Lakecity University",
      "Sri Dev Suman Uttarakhand University",
      "Uttar Banga Krishi Viswavidyalaya",
      "Ayush and Health Sciences University of Chhattisgarh",
      "Shri Vishwakarma Skill University",
      "Geetanjali University",
      "University of Horticultural Sciences, Bagalkot",
      "Mahatma Gandhi University, Nalgonda",
      "Kerala Kalamandalam",
      "Gangadhar Meher University",
      "Bastar Vishwavidyalaya",
      "Sido Kanhu Murmu University",
      "Bhupendra Narayan Mandal University",
      "Rani Lakshmi Bai Central Agricultural University",
      "Cooch Behar Panchanan Barma University",
      "RKDF University",
      "University of Technology and Management",
      "Srimanta Sankaradeva University of Health Sciences",
      "Maharishi University of Management and Technology",
      "Karnataka State Women's University",
      "Maharaja Chhatrasal Bundelkhand University",
      "University of Technology",
      "Navrachana University",
      "Uttarakhand Ayurved University",
      "Raj Rishi Bharthari Matsya University",
      "Banda University of Agriculture and Technology",
      "University of Agricultural Sciences, Raichur",
      "Sidho Kanho Birsha University",
      "Uttaranchal Sanskrit University",
      "Central University of Tibetan Studies",
      "Institute of Advanced Studies in Education",
      "Guru Ravidas Ayurved University",
      "Nanaji Deshmukh Veterinary Science University",
      "Guru Kashi University",
      "Indus University",
      "Sardar Patel University of Police, Security and Criminal Justice",
      "Oriental University",
      "ICFAI University, Jharkhand",
      "Dr. B.R. Ambedkar University",
      "National Institute of Pharmaceutical Education and Research, Guwahati",
      "Himgiri ZEE University",
      "Davangere University",
      "Raksha Shakti University",
      "TransDisciplinary University",
      "JIS University",
      "Hemwati Nandan Bahuguna Medical University",
      "Uttarakhand University of Horticulture and Forestry",
      "Mahatma Jyoti Rao Phoole University",
      "Raffles University",
      "Shree Somnath Sanskrit University",
      "ICFAI University, Jaipur",
      "Assam Rajiv Gandhi University of Cooperative Management",
      "Thunchath Ezhuthachan Malayalam University",
      "Shri Venkateshwara University",
      "Indian Institute of Information Technology, Manipur",
      "Sangai International University",
      "Nava Nalanda Mahavihara",
      "Shri Vaishnav Vidyapeeth Vishwavidyalaya",
      "Indira Kala Sangeet Vishwavidyalaya",
      "MVN University",
      "TeamLease Skills University",
      "Vijayanagara Sri Krishnadevaraya University",
      "St. Xavier's University",
      "Monad University",
      "Karnataka Sanskrit University",
      "Karnataka Veterinary, Animal and Fisheries Sciences University",
      "ICFAI University, Sikkim",
      "Suamandeep Vidyapeeth",
      "KLE Technological University",
      "Jagadguru Ramanandacharya Rajasthan Sanskrit University",
      "Govind Guru Tribal University",
      "Indian Institute of Information Technology, Kottayam",
      "Sri Devaraj Urs Academy of Higher Education and Research",
      "Adesh University",
      "Baddi University of Emerging Sciences and Technologies",
      "Manav Bharti University",
      "Maharashtra National Law University, Nagpur",
      "Sampurnanand Sanskrit Vishvavidyalaya",
      "Nehru Gram Bharati Vishwavidyalaya",
      "Mahatma Gandhi Chitrakoot Gramoday Vishwavidyalaya",
      "GIET University",
      "University of Agricultural and Horticultural Sciences, Shivamogga",
      "Martin Luther Christian University",
      "Dr. A.P.J Abdul Kalam University",
      "O.P. Jindal University",
      "Maharishi University",
      "Shridhar University",
      "Jagan Nath University",
      "Nilamber-Pitamber University",
      "Apex Professional University",
      "Jodhpur National University",
      "Kushabhau Thakre Patrakarita Avam Jansanchar University",
      "Shri Jagannath Sanskrit Vishvavidyalaya",
      "IIMT University",
      "Utkal University of Culture",
      "Sangam University",
      "Maharashtra National Law University Mumbai",
      "Allahabad State University",
      "EIILM University",
      "Sabarmati University",
      "ISBM University",
      "IFTM University",
      "Jagadguru Rambhadracharya Handicapped University",
      "Manipur Technical University",
      "Mohammad Ali Jauhar University",
      "National Institute of Pharmaceutical Education and Research, Rae Bareli",
      "Gulbarga University",
      "Bhakta Kavi Narsinh Mehta University",
      "Sri Siddhartha Academy of Higher Education",
      "Cluster University of Jammu",
      "Khwaja Moinuddin Chishti Urdu, Arabi-Farsi University",
      "Kamdhenu University",
      "Narendra Dev University of Agriculture and Technology",
      "University of Patanjali",
      "Mandsaur University",
      "BAHRA University",
      "Sri Satya Sai University of Technology and Medical Sciences",
      "Symbiosis University of Applied Sciences",
      "Eternal University",
      "Baba Mastnath University",
      "Tamil Nadu National Law University",
      "Bhagwant University",
      "Raja Mansingh Tomar Music and Arts University",
      "Tantia University",
      "Al-Falah University",
      "Jananayak Chandrashekhar University",
      "Sri Sai University",
      "William Carey University, Meghalaya",
      "Chhattisgarh Kamdhenu Vishwavidyalaya",
      "ITM Vocational University",
      "Srinivas University",
      "G H Raisoni University",
      "Jharkhand Rai University",
      "Maharaja Agrasen University",
      "Bankura University",
      "National Institute of Pharmaceutical Education and Research, Hajipur",
      "P P Savani University",
      "Mahatma Gandhi University of Medical Sciences and Technology",
      "The Neotia University",
      "Raiganj University",
      "Karpagam Academy of Higher Education",
      "Indrashil University",
      "Dakshina Bharat Hindi Prachar Sabha",
      "G.L.S. University",
      "Sant Baba Bhag Singh University",
      "Sai Nath University",
      "Indian Institute of Public Health",
      "NIILM University",
      "Mahapurusha Srimanta Sankaradeva Viswavidyalaya",
      "Sri Venkateswara Vedic University",
      "Arni University",
      "C.U. Shah University",
      "Meenakshi Academy of Higher Education and Research",
      "Assam Women's University",
      "Maharishi Markandeshwar University, Solan",
      "Himalayan Garhwal University",
      "Indian Institute of Information Technology, Kalyani",
      "Era University",
      "Pratap University",
      "Atal Bihari Vajpayee Hindi Vishwavidyalaya",
      "Seacom Skills University",
      "Kameshwar Singh Darbhanga Sanskrit University",
      "Shri Govind Guru University",
      "Children's University",
      "JS University",
      "Shri Jagdishprasad Jhabrmal Tibrewala University",
      "Bhatkhande Music Institute",
      "Institute of Advanced Research",
      "Indian Institute of Information Technology, Lucknow",
      "Bhagat Phool Singh Mahila Vishwavidyalaya",
      "Sunrise University",
      "Sarala Birla University",
      "ICFAI University, Himachal Pradesh",
      "Swami Vivekanand University",
      "Binod Bihari Mahto Koyalanchal University",
      "Rama Devi Women's University",
      "West Bengal University of Teachers' Training, Education Planning and Administration",
      "LNCT University",
      "ICFAI University, Raipur",
      "Maharashtra National Law University, Aurangabad",
      "Sanchi University of Buddhist-Indic Studies",
      "Sanjay Ghodawat University",
      "Sri Konda Laxman Telangana State Horticultural University",
      "Maharishi Markandeshwar University, Sadopur",
      "ICFAI University, Nagaland",
      "Usha Martin University",
      "Kumar Bhaskar Varma Sanskrit and Ancient Studies University",
      "Sarvepalli Radhakrishnan University",
      "GSFC University",
      "ICFAI University, Mizoram",
      "Starex University",
      "National Institute of Pharmaceutical Education and Research,Kolkata",
      "Arka Jain University",
      "Shri Guru Ram Rai University",
      "Vinayaka Missions Sikkim University",
      "K.K. University",
      "Apex University",
      "Diamond Harbour Women's University",
      "State University of Performing and Visual Arts",
      "Bengaluru North University",
      "Akal University",
      "JSS Science and Technology University",
      "YBN University",
      "Bhupal Nobles University",
      "Rajiv Gandhi National Aviation University",
      "North East Frontier Technical University",
      "Indus International University",
      "Jaypee University Anoopshahr",
      "ICFAI University, Meghalaya",
      "Haridev Joshi University of Journalism and Mass Communication",
      "KSGH Music and Performing Arts University",
      "Pragyan International University",
      "Abhilashi University",
      "SRM University, Sikkim",
      "Maharishi Arvind University, Jaipur",
      "Sankalchand Patel University",
      "Spicer Adventist University",
      "The Sanskrit College and University",
      "Rai Technology University",
      "Indira Gandhi Technological and Medical Sciences University",
      "Swarnim Startup and Innovation University",
      "Dr. B.R. Ambedkar University of Social Sciences",
      "Maharaja Bir Bikram University",
      "National Sports University",
      "Karnataka Janapada Vishwavidyalaya",
      "Pacific Medical University",
      "CMJ University",
      "Karnavati University",
      "Tamil Nadu Music and Fine Arts University",
      "Bareilly International University",
      "Plastindia International University",
      "Sri Guru Ram Das University of Health Sciences",
      "Motherhood University",
      "St. Joseph University",
      "Central University of Andhra Pradesh",
      "Gujarat University of Transplantation Sciences",
      "Lakulish Yoga University",
      "Karnataka State Rural Development and Panchayat Raj University",
      "Khallikote University",
      "Madhyanchal Professional University",
      "P.K. University",
      "Malwanchal University",
      "Arunodaya University",
      "Ras Bihari Bose Subharti University",
      "Uttarakhand Aawasiya Vishwavidyalaya, Almora",
      "Sharnbasva University",
      "Maulana Azad University, Jodhpur",
      "Sai Tirupati University",
      "Manipur University of Culture",
      "Shri Guru Ram Rai Education Mission",
      "Manav Rachna International Institute of Research and Studies",
      "Manav Rachna University",
      "Sandip University, Sijoul",
      "Jharkhand Raksha Shakti University",
      "Indian Institute of Foreign Trade",
      "Dr. Sarvepalli Radhakrishnan Rajasthan Ayurved University"]
    }
  }
}